const raw = {
  "owner_id": 186556,
  "event": "2023",
  "members": {
    "140796": {
      "stars": 17,
      "global_score": 0,
      "last_star_ts": 1702646410,
      "local_score": 1727,
      "id": 140796,
      "name": "Donnie Mattingly",
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 103845,
            "get_star_ts": 1701434921
          },
          "2": {
            "star_index": 206610,
            "get_star_ts": 1701462574
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701535358,
            "star_index": 433668
          },
          "2": {
            "get_star_ts": 1701535801,
            "star_index": 435327
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1701692998,
            "star_index": 888606
          }
        },
        "5": {
          "1": {
            "star_index": 1469464,
            "get_star_ts": 1701921462
          }
        },
        "6": {
          "1": {
            "star_index": 1362733,
            "get_star_ts": 1701869191
          },
          "2": {
            "star_index": 1363520,
            "get_star_ts": 1701869483
          }
        },
        "7": {
          "1": {
            "star_index": 1820347,
            "get_star_ts": 1702086452
          },
          "2": {
            "get_star_ts": 1702127372,
            "star_index": 1906802
          }
        },
        "9": {
          "1": {
            "star_index": 1923971,
            "get_star_ts": 1702134833
          },
          "2": {
            "star_index": 1932705,
            "get_star_ts": 1702138596
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1702340533,
            "star_index": 2270755
          }
        },
        "13": {
          "1": {
            "star_index": 2470643,
            "get_star_ts": 1702504458
          },
          "2": {
            "star_index": 2474428,
            "get_star_ts": 1702507519
          }
        },
        "14": {
          "1": {
            "star_index": 2582088,
            "get_star_ts": 1702605823
          }
        },
        "15": {
          "1": {
            "star_index": 2641350,
            "get_star_ts": 1702646410
          }
        }
      }
    },
    "186556": {
      "global_score": 0,
      "stars": 31,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701430511,
            "star_index": 89405
          },
          "2": {
            "star_index": 102851,
            "get_star_ts": 1701434627
          }
        },
        "2": {
          "1": {
            "star_index": 421452,
            "get_star_ts": 1701532021
          },
          "2": {
            "get_star_ts": 1701532959,
            "star_index": 424865
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1701623520,
            "star_index": 673876
          },
          "2": {
            "star_index": 680741,
            "get_star_ts": 1701625567
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1701692910,
            "star_index": 888302
          },
          "2": {
            "star_index": 900935,
            "get_star_ts": 1701696492
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1701776652,
            "star_index": 1118254
          },
          "2": {
            "star_index": 1143151,
            "get_star_ts": 1701786697
          }
        },
        "6": {
          "1": {
            "star_index": 1431917,
            "get_star_ts": 1701895591
          },
          "2": {
            "star_index": 1433463,
            "get_star_ts": 1701896200
          }
        },
        "7": {
          "1": {
            "star_index": 1633212,
            "get_star_ts": 1701990688
          },
          "2": {
            "star_index": 1636872,
            "get_star_ts": 1701993086
          }
        },
        "8": {
          "1": {
            "star_index": 1721689,
            "get_star_ts": 1702034793
          },
          "2": {
            "get_star_ts": 1702041166,
            "star_index": 1735707
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1702122891,
            "star_index": 1896514
          },
          "2": {
            "get_star_ts": 1702123375,
            "star_index": 1897665
          }
        },
        "10": {
          "1": {
            "star_index": 2054173,
            "get_star_ts": 1702216634
          },
          "2": {
            "star_index": 2126696,
            "get_star_ts": 1702258553
          }
        },
        "11": {
          "1": {
            "star_index": 2205166,
            "get_star_ts": 1702303051
          },
          "2": {
            "get_star_ts": 1702305676,
            "star_index": 2210183
          }
        },
        "12": {
          "1": {
            "star_index": 2355287,
            "get_star_ts": 1702411069
          }
        },
        "13": {
          "1": {
            "star_index": 2818501,
            "get_star_ts": 1702827351
          },
          "2": {
            "get_star_ts": 1702838610,
            "star_index": 2830271
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1702840904,
            "star_index": 2832633
          },
          "2": {
            "star_index": 2846584,
            "get_star_ts": 1702853973
          }
        },
        "15": {
          "1": {
            "star_index": 2847163,
            "get_star_ts": 1702854657
          },
          "2": {
            "get_star_ts": 1702858406,
            "star_index": 2849886
          }
        },
        "16": {
          "1": {
            "get_star_ts": 1702940279,
            "star_index": 2927864
          },
          "2": {
            "get_star_ts": 1702941737,
            "star_index": 2929082
          }
        }
      },
      "name": "Chad Orwig",
      "last_star_ts": 1702941737,
      "local_score": 3297,
      "id": 186556
    },
    "188240": {
      "global_score": 0,
      "stars": 0,
      "completion_day_level": {},
      "name": "trevcor",
      "last_star_ts": 0,
      "id": 188240,
      "local_score": 0
    },
    "188248": {
      "id": 188248,
      "last_star_ts": 0,
      "local_score": 0,
      "name": "Matthew Keelan",
      "completion_day_level": {},
      "stars": 0,
      "global_score": 0
    },
    "188249": {
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701636038,
            "star_index": 715255
          },
          "2": {
            "star_index": 727547,
            "get_star_ts": 1701639734
          }
        },
        "2": {
          "1": {
            "star_index": 733962,
            "get_star_ts": 1701641856
          },
          "2": {
            "star_index": 735368,
            "get_star_ts": 1701642336
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1701665976,
            "star_index": 770354
          },
          "2": {
            "star_index": 785266,
            "get_star_ts": 1701667668
          }
        },
        "4": {
          "1": {
            "star_index": 792849,
            "get_star_ts": 1701668807
          },
          "2": {
            "get_star_ts": 1701726156,
            "star_index": 1009133
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1701872636,
            "star_index": 1372348
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1701883985,
            "star_index": 1402826
          },
          "2": {
            "get_star_ts": 1701884468,
            "star_index": 1403942
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1702042923,
            "star_index": 1739816
          },
          "2": {
            "get_star_ts": 1702137390,
            "star_index": 1929823
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1702138585,
            "star_index": 1932670
          }
        },
        "9": {
          "1": {
            "star_index": 2473473,
            "get_star_ts": 1702506687
          },
          "2": {
            "star_index": 2474879,
            "get_star_ts": 1702507927
          }
        },
        "10": {
          "1": {
            "star_index": 3268371,
            "get_star_ts": 1703436208
          },
          "2": {
            "get_star_ts": 1703439925,
            "star_index": 3270289
          }
        },
        "11": {
          "1": {
            "star_index": 2856271,
            "get_star_ts": 1702872161
          },
          "2": {
            "get_star_ts": 1702916191,
            "star_index": 2902388
          }
        },
        "13": {
          "1": {
            "star_index": 2926230,
            "get_star_ts": 1702938464
          }
        },
        "14": {
          "1": {
            "star_index": 2933877,
            "get_star_ts": 1702950530
          }
        },
        "15": {
          "1": {
            "star_index": 3136771,
            "get_star_ts": 1703214716
          },
          "2": {
            "star_index": 3199554,
            "get_star_ts": 1703315672
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1703376058,
            "star_index": 3237252
          },
          "2": {
            "star_index": 3241046,
            "get_star_ts": 1703387975
          }
        },
        "19": {
          "1": {
            "get_star_ts": 1703456880,
            "star_index": 3278262
          }
        }
      },
      "last_star_ts": 1703456880,
      "local_score": 2490,
      "id": 188249,
      "name": "Austin Assavavallop",
      "global_score": 0,
      "stars": 27
    },
    "189285": {
      "stars": 0,
      "global_score": 0,
      "name": "Steven Porter",
      "last_star_ts": 0,
      "local_score": 0,
      "id": 189285,
      "completion_day_level": {}
    },
    "250536": {
      "global_score": 0,
      "stars": 23,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701436722,
            "star_index": 109950
          },
          "2": {
            "get_star_ts": 1701442773,
            "star_index": 133307
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701494818,
            "star_index": 279048
          },
          "2": {
            "star_index": 282096,
            "get_star_ts": 1701495196
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1701581633,
            "star_index": 540955
          },
          "2": {
            "star_index": 548897,
            "get_star_ts": 1701583509
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1701667460,
            "star_index": 783505
          },
          "2": {
            "get_star_ts": 1701668618,
            "star_index": 791816
          }
        },
        "5": {
          "1": {
            "star_index": 1066011,
            "get_star_ts": 1701756612
          },
          "2": {
            "get_star_ts": 1701790236,
            "star_index": 1152731
          }
        },
        "6": {
          "1": {
            "star_index": 1257781,
            "get_star_ts": 1701839471
          },
          "2": {
            "star_index": 1268617,
            "get_star_ts": 1701840410
          }
        },
        "7": {
          "1": {
            "star_index": 1479619,
            "get_star_ts": 1701927571
          },
          "2": {
            "get_star_ts": 1701929624,
            "star_index": 1488236
          }
        },
        "8": {
          "1": {
            "star_index": 1660191,
            "get_star_ts": 1702012825
          },
          "2": {
            "get_star_ts": 1702014728,
            "star_index": 1669286
          }
        },
        "9": {
          "1": {
            "star_index": 1835329,
            "get_star_ts": 1702099254
          },
          "2": {
            "get_star_ts": 1702099368,
            "star_index": 1836170
          }
        },
        "10": {
          "1": {
            "star_index": 2002591,
            "get_star_ts": 1702187290
          },
          "2": {
            "get_star_ts": 1702221901,
            "star_index": 2064266
          }
        },
        "11": {
          "1": {
            "star_index": 2144318,
            "get_star_ts": 1702273160
          },
          "2": {
            "get_star_ts": 1702274413,
            "star_index": 2148846
          }
        },
        "12": {
          "1": {
            "star_index": 2323683,
            "get_star_ts": 1702387692
          }
        }
      },
      "id": 250536,
      "last_star_ts": 1702387692,
      "local_score": 2663,
      "name": "Jeremy Lizza"
    },
    "254702": {
      "global_score": 0,
      "stars": 50,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1702330023,
            "star_index": 2255872
          },
          "2": {
            "get_star_ts": 1702332959,
            "star_index": 2261207
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1702349259,
            "star_index": 2277003
          },
          "2": {
            "get_star_ts": 1702349710,
            "star_index": 2277332
          }
        },
        "3": {
          "1": {
            "star_index": 2279589,
            "get_star_ts": 1702353089
          },
          "2": {
            "star_index": 2279871,
            "get_star_ts": 1702353512
          }
        },
        "4": {
          "1": {
            "star_index": 2280745,
            "get_star_ts": 1702354936
          },
          "2": {
            "get_star_ts": 1702357450,
            "star_index": 2282309
          }
        },
        "5": {
          "1": {
            "star_index": 2344149,
            "get_star_ts": 1702402782
          },
          "2": {
            "get_star_ts": 1702411241,
            "star_index": 2355569
          }
        },
        "6": {
          "1": {
            "star_index": 2357343,
            "get_star_ts": 1702412430
          },
          "2": {
            "get_star_ts": 1702412708,
            "star_index": 2357748
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1702417171,
            "star_index": 2364691
          },
          "2": {
            "get_star_ts": 1702417870,
            "star_index": 2365705
          }
        },
        "8": {
          "1": {
            "star_index": 2376880,
            "get_star_ts": 1702428741
          },
          "2": {
            "star_index": 2668363,
            "get_star_ts": 1702668138
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1702669599,
            "star_index": 2669812
          },
          "2": {
            "star_index": 2670431,
            "get_star_ts": 1702670174
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1702673543,
            "star_index": 2673984
          },
          "2": {
            "get_star_ts": 1702951930,
            "star_index": 2934477
          }
        },
        "11": {
          "1": {
            "star_index": 2997030,
            "get_star_ts": 1703018919
          },
          "2": {
            "star_index": 2997443,
            "get_star_ts": 1703019304
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1702367928,
            "star_index": 2298977
          },
          "2": {
            "get_star_ts": 1704891758,
            "star_index": 3529905
          }
        },
        "13": {
          "1": {
            "star_index": 3073469,
            "get_star_ts": 1703123757
          },
          "2": {
            "star_index": 3073610,
            "get_star_ts": 1703124085
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1703126057,
            "star_index": 3074389
          },
          "2": {
            "get_star_ts": 1703130967,
            "star_index": 3076120
          }
        },
        "15": {
          "1": {
            "star_index": 3076382,
            "get_star_ts": 1703131741
          },
          "2": {
            "star_index": 3076796,
            "get_star_ts": 1703133049
          }
        },
        "16": {
          "1": {
            "star_index": 3077364,
            "get_star_ts": 1703134832
          },
          "2": {
            "star_index": 3079445,
            "get_star_ts": 1703135856
          }
        },
        "17": {
          "1": {
            "star_index": 3512223,
            "get_star_ts": 1704687389
          },
          "2": {
            "get_star_ts": 1704687980,
            "star_index": 3512247
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1703192954,
            "star_index": 3126001
          },
          "2": {
            "get_star_ts": 1703623677,
            "star_index": 3341296
          }
        },
        "19": {
          "1": {
            "star_index": 3342176,
            "get_star_ts": 1703625764
          },
          "2": {
            "get_star_ts": 1703701828,
            "star_index": 3362200
          }
        },
        "20": {
          "1": {
            "get_star_ts": 1703705637,
            "star_index": 3363530
          },
          "2": {
            "star_index": 3366792,
            "get_star_ts": 1703714238
          }
        },
        "21": {
          "1": {
            "star_index": 3512326,
            "get_star_ts": 1704689612
          },
          "2": {
            "star_index": 3527759,
            "get_star_ts": 1704854914
          }
        },
        "22": {
          "1": {
            "get_star_ts": 1704212913,
            "star_index": 3456539
          },
          "2": {
            "get_star_ts": 1704216200,
            "star_index": 3457266
          }
        },
        "23": {
          "1": {
            "star_index": 3457737,
            "get_star_ts": 1704218731
          },
          "2": {
            "star_index": 3495627,
            "get_star_ts": 1704510802
          }
        },
        "24": {
          "1": {
            "star_index": 3458508,
            "get_star_ts": 1704222743
          },
          "2": {
            "star_index": 3460001,
            "get_star_ts": 1704230243
          }
        },
        "25": {
          "1": {
            "star_index": 3511861,
            "get_star_ts": 1704680442
          },
          "2": {
            "star_index": 3529906,
            "get_star_ts": 1704891765
          }
        }
      },
      "id": 254702,
      "last_star_ts": 1704891765,
      "local_score": 4694,
      "name": "Brian O'Connor"
    },
    "268714": {
      "stars": 3,
      "global_score": 0,
      "last_star_ts": 1701663787,
      "local_score": 246,
      "id": 268714,
      "name": "Matt Ranlett",
      "completion_day_level": {
        "2": {
          "1": {
            "star_index": 729486,
            "get_star_ts": 1701640351
          },
          "2": {
            "star_index": 732519,
            "get_star_ts": 1701641365
          }
        },
        "3": {
          "1": {
            "star_index": 768078,
            "get_star_ts": 1701663787
          }
        }
      }
    },
    "351893": {
      "completion_day_level": {},
      "name": "Hooman Ebrahimi",
      "id": 351893,
      "last_star_ts": 0,
      "local_score": 0,
      "global_score": 0,
      "stars": 0
    },
    "372160": {
      "stars": 10,
      "global_score": 0,
      "last_star_ts": 1705277330,
      "local_score": 588,
      "id": 372160,
      "name": "Alex Consunji",
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 3556203,
            "get_star_ts": 1705263187
          },
          "2": {
            "star_index": 3556405,
            "get_star_ts": 1705265901
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1704682967,
            "star_index": 3511998
          },
          "2": {
            "get_star_ts": 1704683622,
            "star_index": 3512028
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1705272792,
            "star_index": 3556980
          },
          "2": {
            "get_star_ts": 1705277330,
            "star_index": 3557268
          }
        },
        "6": {
          "1": {
            "star_index": 3555482,
            "get_star_ts": 1705255457
          },
          "2": {
            "star_index": 3555487,
            "get_star_ts": 1705255523
          }
        },
        "9": {
          "1": {
            "star_index": 3556008,
            "get_star_ts": 1705260961
          },
          "2": {
            "star_index": 3556052,
            "get_star_ts": 1705261464
          }
        }
      }
    },
    "372360": {
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 176987,
            "get_star_ts": 1701453831
          },
          "2": {
            "star_index": 188729,
            "get_star_ts": 1701457212
          }
        },
        "2": {
          "1": {
            "star_index": 634317,
            "get_star_ts": 1701611457
          },
          "2": {
            "star_index": 635974,
            "get_star_ts": 1701611957
          }
        },
        "3": {
          "1": {
            "star_index": 661777,
            "get_star_ts": 1701619880
          },
          "2": {
            "get_star_ts": 1701647595,
            "star_index": 747575
          }
        },
        "4": {
          "1": {
            "star_index": 916590,
            "get_star_ts": 1701700619
          },
          "2": {
            "get_star_ts": 1701702620,
            "star_index": 924109
          }
        },
        "5": {
          "1": {
            "star_index": 1144975,
            "get_star_ts": 1701787374
          },
          "2": {
            "star_index": 1149668,
            "get_star_ts": 1701789135
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1701872653,
            "star_index": 1372393
          },
          "2": {
            "get_star_ts": 1701872834,
            "star_index": 1372897
          }
        },
        "7": {
          "1": {
            "star_index": 1582490,
            "get_star_ts": 1701967734
          },
          "2": {
            "star_index": 1584057,
            "get_star_ts": 1701968396
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1702046721,
            "star_index": 1749118
          },
          "2": {
            "get_star_ts": 1702047751,
            "star_index": 1751663
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1702165906,
            "star_index": 1983574
          },
          "2": {
            "star_index": 1984216,
            "get_star_ts": 1702166412
          }
        },
        "10": {
          "1": {
            "star_index": 2083268,
            "get_star_ts": 1702231339
          },
          "2": {
            "star_index": 2128576,
            "get_star_ts": 1702261115
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1702305563,
            "star_index": 2209951
          },
          "2": {
            "star_index": 2210552,
            "get_star_ts": 1702305868
          }
        },
        "12": {
          "1": {
            "star_index": 2329308,
            "get_star_ts": 1702392017
          },
          "2": {
            "get_star_ts": 1702483422,
            "star_index": 2443596
          }
        },
        "13": {
          "1": {
            "star_index": 2455262,
            "get_star_ts": 1702492808
          },
          "2": {
            "star_index": 2460917,
            "get_star_ts": 1702497455
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1702574619,
            "star_index": 2552756
          },
          "2": {
            "get_star_ts": 1702587885,
            "star_index": 2567655
          }
        },
        "15": {
          "1": {
            "star_index": 2650498,
            "get_star_ts": 1702652772
          },
          "2": {
            "get_star_ts": 1702655168,
            "star_index": 2653869
          }
        },
        "16": {
          "1": {
            "star_index": 2851871,
            "get_star_ts": 1702862052
          },
          "2": {
            "star_index": 2852193,
            "get_star_ts": 1702862706
          }
        },
        "17": {
          "1": {
            "star_index": 3058775,
            "get_star_ts": 1703102123
          },
          "2": {
            "get_star_ts": 1703103559,
            "star_index": 3060052
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1702935204,
            "star_index": 2922735
          },
          "2": {
            "get_star_ts": 1702936000,
            "star_index": 2923636
          }
        },
        "19": {
          "1": {
            "get_star_ts": 1703015846,
            "star_index": 2993962
          },
          "2": {
            "star_index": 3012423,
            "get_star_ts": 1703043966
          }
        },
        "20": {
          "1": {
            "get_star_ts": 1703089682,
            "star_index": 3048749
          },
          "2": {
            "get_star_ts": 1703097007,
            "star_index": 3054730
          }
        },
        "21": {
          "1": {
            "star_index": 3108225,
            "get_star_ts": 1703170241
          },
          "2": {
            "get_star_ts": 1703213638,
            "star_index": 3136455
          }
        },
        "22": {
          "1": {
            "get_star_ts": 1703264379,
            "star_index": 3170409
          },
          "2": {
            "star_index": 3170612,
            "get_star_ts": 1703264643
          }
        },
        "23": {
          "1": {
            "get_star_ts": 1703341248,
            "star_index": 3214976
          },
          "2": {
            "star_index": 3239359,
            "get_star_ts": 1703381903
          }
        },
        "24": {
          "1": {
            "star_index": 3272049,
            "get_star_ts": 1703443684
          },
          "2": {
            "star_index": 3274482,
            "get_star_ts": 1703448914
          }
        },
        "25": {
          "1": {
            "star_index": 3291339,
            "get_star_ts": 1703488766
          },
          "2": {
            "star_index": 3291340,
            "get_star_ts": 1703488769
          }
        }
      },
      "last_star_ts": 1703488769,
      "local_score": 5438,
      "id": 372360,
      "name": "Corey Lamb",
      "global_score": 0,
      "stars": 50
    },
    "372419": {
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701437766,
            "star_index": 113665
          },
          "2": {
            "star_index": 258409,
            "get_star_ts": 1701485463
          }
        },
        "2": {
          "1": {
            "star_index": 465171,
            "get_star_ts": 1701544806
          },
          "2": {
            "get_star_ts": 1701550202,
            "star_index": 482033
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1701630133,
            "star_index": 695447
          },
          "2": {
            "star_index": 747112,
            "get_star_ts": 1701647368
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1701693641,
            "star_index": 890853
          },
          "2": {
            "star_index": 1181701,
            "get_star_ts": 1701801115
          }
        },
        "6": {
          "1": {
            "star_index": 1368340,
            "get_star_ts": 1701871191
          },
          "2": {
            "get_star_ts": 1701873293,
            "star_index": 1374237
          }
        },
        "8": {
          "1": {
            "star_index": 1818153,
            "get_star_ts": 1702083752
          }
        }
      },
      "last_star_ts": 1702083752,
      "local_score": 1049,
      "id": 372419,
      "name": "Kevin Campbell",
      "global_score": 0,
      "stars": 11
    },
    "375289": {
      "name": "JHahn",
      "local_score": 2826,
      "last_star_ts": 1703889281,
      "id": 375289,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701441542,
            "star_index": 128342
          },
          "2": {
            "star_index": 151023,
            "get_star_ts": 1701447107
          }
        },
        "2": {
          "1": {
            "star_index": 424887,
            "get_star_ts": 1701532966
          },
          "2": {
            "get_star_ts": 1701534714,
            "star_index": 431232
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1701723453,
            "star_index": 999674
          },
          "2": {
            "get_star_ts": 1701725244,
            "star_index": 1006008
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1701727156,
            "star_index": 1012391
          },
          "2": {
            "star_index": 1162833,
            "get_star_ts": 1701793950
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1701807358,
            "star_index": 1198716
          },
          "2": {
            "star_index": 1444303,
            "get_star_ts": 1701900624
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1701903080,
            "star_index": 1449343
          },
          "2": {
            "star_index": 1451927,
            "get_star_ts": 1701904482
          }
        },
        "7": {
          "1": {
            "star_index": 1773197,
            "get_star_ts": 1702057123
          },
          "2": {
            "star_index": 1967019,
            "get_star_ts": 1702155854
          }
        },
        "8": {
          "1": {
            "star_index": 1970874,
            "get_star_ts": 1702157908
          },
          "2": {
            "get_star_ts": 1702223200,
            "star_index": 2066886
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1702225099,
            "star_index": 2070843
          },
          "2": {
            "star_index": 2072483,
            "get_star_ts": 1702225877
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1702309562,
            "star_index": 2217571
          },
          "2": {
            "get_star_ts": 1702759623,
            "star_index": 2763777
          }
        },
        "11": {
          "1": {
            "star_index": 2828614,
            "get_star_ts": 1702837008
          },
          "2": {
            "get_star_ts": 1702838062,
            "star_index": 2829664
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1702916094,
            "star_index": 2902265
          },
          "2": {
            "star_index": 2909363,
            "get_star_ts": 1702922798
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1703196017,
            "star_index": 3128326
          },
          "2": {
            "get_star_ts": 1703264987,
            "star_index": 3170873
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1703274929,
            "star_index": 3177565
          },
          "2": {
            "star_index": 3405846,
            "get_star_ts": 1703880600
          }
        },
        "15": {
          "1": {
            "star_index": 3406580,
            "get_star_ts": 1703883171
          },
          "2": {
            "star_index": 3408361,
            "get_star_ts": 1703889281
          }
        }
      },
      "stars": 30,
      "global_score": 0
    },
    "384082": {
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701407709,
            "star_index": 6917
          },
          "2": {
            "star_index": 11918,
            "get_star_ts": 1701408533
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701494632,
            "star_index": 277446
          },
          "2": {
            "star_index": 280485,
            "get_star_ts": 1701494993
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1701581465,
            "star_index": 540173
          },
          "2": {
            "get_star_ts": 1701582230,
            "star_index": 543701
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1701666895,
            "star_index": 777869
          },
          "2": {
            "star_index": 784516,
            "get_star_ts": 1701667577
          }
        },
        "5": {
          "1": {
            "star_index": 1057684,
            "get_star_ts": 1701754490
          },
          "2": {
            "get_star_ts": 1701767495,
            "star_index": 1094807
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1701839529,
            "star_index": 1258614
          },
          "2": {
            "star_index": 1259511,
            "get_star_ts": 1701839594
          }
        },
        "7": {
          "1": {
            "star_index": 1479767,
            "get_star_ts": 1701927603
          },
          "2": {
            "get_star_ts": 1701928014,
            "star_index": 1481704
          }
        },
        "8": {
          "1": {
            "star_index": 1656064,
            "get_star_ts": 1702012264
          },
          "2": {
            "get_star_ts": 1702014189,
            "star_index": 1667144
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1702099477,
            "star_index": 1836934
          },
          "2": {
            "get_star_ts": 1702099688,
            "star_index": 1838361
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1702186949,
            "star_index": 2001684
          },
          "2": {
            "get_star_ts": 1702188696,
            "star_index": 2005761
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1702272603,
            "star_index": 2141716
          },
          "2": {
            "get_star_ts": 1702273012,
            "star_index": 2143613
          }
        },
        "12": {
          "1": {
            "star_index": 2284943,
            "get_star_ts": 1702358915
          },
          "2": {
            "star_index": 2296401,
            "get_star_ts": 1702365915
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1702446128,
            "star_index": 2391095
          },
          "2": {
            "star_index": 2393384,
            "get_star_ts": 1702447005
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1702530965,
            "star_index": 2490767
          },
          "2": {
            "star_index": 2497386,
            "get_star_ts": 1702533143
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1702617039,
            "star_index": 2590637
          },
          "2": {
            "star_index": 2599412,
            "get_star_ts": 1702619398
          }
        },
        "16": {
          "1": {
            "star_index": 2697302,
            "get_star_ts": 1702705400
          },
          "2": {
            "star_index": 2698700,
            "get_star_ts": 1702705968
          }
        },
        "17": {
          "1": {
            "get_star_ts": 1702826549,
            "star_index": 2817582
          },
          "2": {
            "star_index": 2819966,
            "get_star_ts": 1702828678
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1702892704,
            "star_index": 2878081
          },
          "2": {
            "get_star_ts": 1702896716,
            "star_index": 2882226
          }
        },
        "19": {
          "1": {
            "get_star_ts": 1702964507,
            "star_index": 2942396
          },
          "2": {
            "star_index": 2946094,
            "get_star_ts": 1702966792
          }
        },
        "20": {
          "1": {
            "star_index": 3045135,
            "get_star_ts": 1703085702
          },
          "2": {
            "star_index": 3045731,
            "get_star_ts": 1703086341
          }
        },
        "21": {
          "1": {
            "get_star_ts": 1703135847,
            "star_index": 3079422
          },
          "2": {
            "star_index": 3124368,
            "get_star_ts": 1703191031
          }
        },
        "22": {
          "1": {
            "get_star_ts": 1703264705,
            "star_index": 3170658
          },
          "2": {
            "get_star_ts": 1703265768,
            "star_index": 3171460
          }
        },
        "23": {
          "1": {
            "star_index": 3193647,
            "get_star_ts": 1703308879
          },
          "2": {
            "get_star_ts": 1703349981,
            "star_index": 3221017
          }
        },
        "24": {
          "1": {
            "star_index": 3244256,
            "get_star_ts": 1703397006
          },
          "2": {
            "star_index": 3266301,
            "get_star_ts": 1703432559
          }
        },
        "25": {
          "1": {
            "get_star_ts": 1703488949,
            "star_index": 3291423
          },
          "2": {
            "get_star_ts": 1703488978,
            "star_index": 3291442
          }
        }
      },
      "name": "Jacob Ambrose",
      "last_star_ts": 1703488978,
      "local_score": 5915,
      "id": 384082,
      "global_score": 0,
      "stars": 50
    },
    "456457": {
      "name": "Matt Collins",
      "id": 456457,
      "last_star_ts": 1703266278,
      "local_score": 2670,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701577589,
            "star_index": 532047
          },
          "2": {
            "get_star_ts": 1701736971,
            "star_index": 1033904
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701742618,
            "star_index": 1040991
          },
          "2": {
            "get_star_ts": 1701743212,
            "star_index": 1041701
          }
        },
        "3": {
          "1": {
            "star_index": 1047892,
            "get_star_ts": 1701748601
          },
          "2": {
            "star_index": 1049146,
            "get_star_ts": 1701749783
          }
        },
        "4": {
          "1": {
            "star_index": 1049858,
            "get_star_ts": 1701750446
          },
          "2": {
            "get_star_ts": 1701751615,
            "star_index": 1051095
          }
        },
        "5": {
          "1": {
            "star_index": 1064646,
            "get_star_ts": 1701756226
          },
          "2": {
            "star_index": 1471215,
            "get_star_ts": 1701923700
          }
        },
        "6": {
          "1": {
            "star_index": 1455232,
            "get_star_ts": 1701906715
          },
          "2": {
            "get_star_ts": 1701906896,
            "star_index": 1455468
          }
        },
        "7": {
          "1": {
            "star_index": 1627748,
            "get_star_ts": 1701987789
          },
          "2": {
            "get_star_ts": 1701997414,
            "star_index": 1641599
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1702073094,
            "star_index": 1803969
          },
          "2": {
            "get_star_ts": 1702149963,
            "star_index": 1955669
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1702157661,
            "star_index": 1970397
          },
          "2": {
            "get_star_ts": 1702159025,
            "star_index": 1972845
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1702224928,
            "star_index": 2070480
          },
          "2": {
            "get_star_ts": 1703186689,
            "star_index": 3121005
          }
        },
        "11": {
          "1": {
            "star_index": 2380370,
            "get_star_ts": 1702434769
          },
          "2": {
            "star_index": 2385069,
            "get_star_ts": 1702443700
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1702742944,
            "star_index": 2744919
          }
        },
        "13": {
          "1": {
            "star_index": 2833678,
            "get_star_ts": 1702841880
          },
          "2": {
            "star_index": 2838270,
            "get_star_ts": 1702846055
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1702859593,
            "star_index": 2850559
          }
        },
        "15": {
          "1": {
            "star_index": 2855397,
            "get_star_ts": 1702869924
          },
          "2": {
            "get_star_ts": 1703209813,
            "star_index": 3135313
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1703266278,
            "star_index": 3171843
          }
        }
      },
      "stars": 29,
      "global_score": 0
    },
    "484824": {
      "global_score": 0,
      "stars": 24,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701459803,
            "star_index": 197285
          },
          "2": {
            "get_star_ts": 1701466093,
            "star_index": 218412
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701574873,
            "star_index": 529238
          },
          "2": {
            "get_star_ts": 1701575217,
            "star_index": 529612
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1701639922,
            "star_index": 728157
          },
          "2": {
            "get_star_ts": 1701641735,
            "star_index": 733620
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1701728740,
            "star_index": 1017273
          },
          "2": {
            "star_index": 1225252,
            "get_star_ts": 1701816951
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1701984225,
            "star_index": 1619868
          },
          "2": {
            "get_star_ts": 1701986569,
            "star_index": 1625218
          }
        },
        "7": {
          "1": {
            "star_index": 1820484,
            "get_star_ts": 1702086643
          },
          "2": {
            "get_star_ts": 1702092678,
            "star_index": 1824491
          }
        },
        "8": {
          "1": {
            "star_index": 1968561,
            "get_star_ts": 1702156653
          },
          "2": {
            "star_index": 2063571,
            "get_star_ts": 1702221537
          }
        },
        "9": {
          "1": {
            "star_index": 2118209,
            "get_star_ts": 1702249994
          },
          "2": {
            "get_star_ts": 1702259036,
            "star_index": 2127056
          }
        },
        "10": {
          "1": {
            "star_index": 2770254,
            "get_star_ts": 1702765511
          }
        },
        "11": {
          "1": {
            "star_index": 3130238,
            "get_star_ts": 1703198670
          },
          "2": {
            "star_index": 3130538,
            "get_star_ts": 1703199129
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1703284689,
            "star_index": 3184484
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1703365667,
            "star_index": 3230985
          }
        },
        "15": {
          "1": {
            "star_index": 3273524,
            "get_star_ts": 1703446808
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1703518853,
            "star_index": 3305916
          }
        },
        "21": {
          "1": {
            "get_star_ts": 1703534973,
            "star_index": 3313686
          }
        }
      },
      "id": 484824,
      "last_star_ts": 1703534973,
      "local_score": 2180,
      "name": "Donny Cheng"
    },
    "502805": {
      "global_score": 0,
      "stars": 41,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 0,
            "get_star_ts": 1701407018
          },
          "2": {
            "star_index": 6254,
            "get_star_ts": 1701407627
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701494180,
            "star_index": 273032
          },
          "2": {
            "get_star_ts": 1701494584,
            "star_index": 277016
          }
        },
        "3": {
          "1": {
            "star_index": 537616,
            "get_star_ts": 1701580962
          },
          "2": {
            "star_index": 539116,
            "get_star_ts": 1701581261
          }
        },
        "4": {
          "1": {
            "star_index": 773922,
            "get_star_ts": 1701666560
          },
          "2": {
            "get_star_ts": 1701667655,
            "star_index": 785170
          }
        },
        "5": {
          "1": {
            "star_index": 1126345,
            "get_star_ts": 1701780127
          },
          "2": {
            "get_star_ts": 1701781357,
            "star_index": 1129419
          }
        },
        "6": {
          "1": {
            "star_index": 1259094,
            "get_star_ts": 1701839563
          },
          "2": {
            "star_index": 1261428,
            "get_star_ts": 1701839729
          }
        },
        "7": {
          "1": {
            "star_index": 1550575,
            "get_star_ts": 1701954415
          },
          "2": {
            "get_star_ts": 1701959073,
            "star_index": 1561547
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1702012120,
            "star_index": 1654896
          },
          "2": {
            "get_star_ts": 1702012967,
            "star_index": 1661055
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1702098982,
            "star_index": 1833098
          },
          "2": {
            "star_index": 1834364,
            "get_star_ts": 1702099134
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1702186814,
            "star_index": 2001395
          },
          "2": {
            "get_star_ts": 1702202758,
            "star_index": 2028085
          }
        },
        "11": {
          "1": {
            "star_index": 2140599,
            "get_star_ts": 1702272394
          },
          "2": {
            "star_index": 2147415,
            "get_star_ts": 1702273979
          }
        },
        "12": {
          "1": {
            "star_index": 2379760,
            "get_star_ts": 1702433632
          },
          "2": {
            "get_star_ts": 1702486601,
            "star_index": 2447690
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1702507806,
            "star_index": 2474737
          },
          "2": {
            "get_star_ts": 1702517363,
            "star_index": 2481677
          }
        },
        "14": {
          "1": {
            "star_index": 2490908,
            "get_star_ts": 1702530999
          },
          "2": {
            "star_index": 2495272,
            "get_star_ts": 1702532305
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1702650910,
            "star_index": 2647688
          },
          "2": {
            "star_index": 2653179,
            "get_star_ts": 1702654700
          }
        },
        "16": {
          "1": {
            "get_star_ts": 1702732122,
            "star_index": 2731316
          },
          "2": {
            "star_index": 2731611,
            "get_star_ts": 1702732376
          }
        },
        "17": {
          "1": {
            "get_star_ts": 1702867003,
            "star_index": 2854098
          },
          "2": {
            "get_star_ts": 1702868252,
            "star_index": 2854680
          }
        },
        "18": {
          "1": {
            "star_index": 3010201,
            "get_star_ts": 1703038168
          },
          "2": {
            "star_index": 3011323,
            "get_star_ts": 1703041041
          }
        },
        "19": {
          "1": {
            "get_star_ts": 1703121493,
            "star_index": 3072593
          },
          "2": {
            "get_star_ts": 1703130630,
            "star_index": 3076003
          }
        },
        "20": {
          "1": {
            "star_index": 3188816,
            "get_star_ts": 1703293511
          },
          "2": {
            "get_star_ts": 1703294896,
            "star_index": 3189282
          }
        },
        "21": {
          "1": {
            "star_index": 3189771,
            "get_star_ts": 1703296547
          }
        }
      },
      "local_score": 4724,
      "last_star_ts": 1703296547,
      "id": 502805,
      "name": "Brenton Bazemore"
    },
    "506833": {
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 108300,
            "get_star_ts": 1701436240
          },
          "2": {
            "star_index": 218820,
            "get_star_ts": 1701466223
          }
        },
        "2": {
          "1": {
            "star_index": 404979,
            "get_star_ts": 1701527509
          },
          "2": {
            "get_star_ts": 1701531702,
            "star_index": 420274
          }
        },
        "3": {
          "1": {
            "star_index": 576264,
            "get_star_ts": 1701593557
          },
          "2": {
            "star_index": 586871,
            "get_star_ts": 1701597230
          }
        },
        "4": {
          "1": {
            "star_index": 867637,
            "get_star_ts": 1701686999
          },
          "2": {
            "get_star_ts": 1701689143,
            "star_index": 875315
          }
        },
        "5": {
          "1": {
            "star_index": 1115411,
            "get_star_ts": 1701775421
          },
          "2": {
            "get_star_ts": 1701779208,
            "star_index": 1124137
          }
        },
        "6": {
          "1": {
            "star_index": 1418570,
            "get_star_ts": 1701890415
          },
          "2": {
            "star_index": 1438599,
            "get_star_ts": 1701898228
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1701939487,
            "star_index": 1514410
          },
          "2": {
            "get_star_ts": 1701941703,
            "star_index": 1520177
          }
        },
        "8": {
          "1": {
            "star_index": 1722390,
            "get_star_ts": 1702035079
          },
          "2": {
            "star_index": 1725189,
            "get_star_ts": 1702036405
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1702198535,
            "star_index": 2021083
          },
          "2": {
            "star_index": 2024846,
            "get_star_ts": 1702200867
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1702203933,
            "star_index": 2030259
          },
          "2": {
            "get_star_ts": 1702245567,
            "star_index": 2111057
          }
        },
        "11": {
          "1": {
            "star_index": 2211380,
            "get_star_ts": 1702306309
          },
          "2": {
            "get_star_ts": 1702322064,
            "star_index": 2240316
          }
        },
        "12": {
          "1": {
            "star_index": 2323487,
            "get_star_ts": 1702387546
          },
          "2": {
            "get_star_ts": 1702471289,
            "star_index": 2427331
          }
        },
        "13": {
          "1": {
            "star_index": 2532596,
            "get_star_ts": 1702558552
          },
          "2": {
            "star_index": 2681301,
            "get_star_ts": 1702680649
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1702681268,
            "star_index": 2681827
          },
          "2": {
            "get_star_ts": 1702683739,
            "star_index": 2683753
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1702682061,
            "star_index": 2682476
          },
          "2": {
            "get_star_ts": 1702688484,
            "star_index": 2686565
          }
        },
        "16": {
          "1": {
            "star_index": 2776913,
            "get_star_ts": 1702773644
          },
          "2": {
            "get_star_ts": 1702780789,
            "star_index": 2780336
          }
        },
        "17": {
          "1": {
            "star_index": 2817318,
            "get_star_ts": 1702826345
          },
          "2": {
            "get_star_ts": 1702834628,
            "star_index": 2826183
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1702941459,
            "star_index": 2928863
          },
          "2": {
            "get_star_ts": 1702957576,
            "star_index": 2936704
          }
        },
        "19": {
          "1": {
            "star_index": 3122490,
            "get_star_ts": 1703188678
          },
          "2": {
            "get_star_ts": 1703200579,
            "star_index": 3131441
          }
        },
        "20": {
          "1": {
            "get_star_ts": 1703678246,
            "star_index": 3353962
          },
          "2": {
            "get_star_ts": 1703724940,
            "star_index": 3370003
          }
        },
        "21": {
          "1": {
            "star_index": 3260259,
            "get_star_ts": 1703422632
          },
          "2": {
            "star_index": 3262220,
            "get_star_ts": 1703425814
          }
        },
        "22": {
          "1": {
            "get_star_ts": 1703679254,
            "star_index": 3354237
          },
          "2": {
            "star_index": 3355813,
            "get_star_ts": 1703684365
          }
        },
        "23": {
          "1": {
            "star_index": 3354469,
            "get_star_ts": 1703680110
          },
          "2": {
            "get_star_ts": 1703719800,
            "star_index": 3368752
          }
        },
        "24": {
          "1": {
            "get_star_ts": 1703444137,
            "star_index": 3272277
          },
          "2": {
            "star_index": 3354089,
            "get_star_ts": 1703678748
          }
        },
        "25": {
          "1": {
            "get_star_ts": 1703774117,
            "star_index": 3379633
          },
          "2": {
            "get_star_ts": 1703774122,
            "star_index": 3379636
          }
        }
      },
      "name": "Carl Newton",
      "local_score": 5484,
      "last_star_ts": 1703774122,
      "id": 506833,
      "global_score": 0,
      "stars": 50
    },
    "619828": {
      "stars": 8,
      "global_score": 0,
      "id": 619828,
      "last_star_ts": 1702151038,
      "local_score": 650,
      "name": "Raz-SB",
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 189327,
            "get_star_ts": 1701457404
          },
          "2": {
            "star_index": 262105,
            "get_star_ts": 1701488800
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701537135,
            "star_index": 440082
          },
          "2": {
            "star_index": 446402,
            "get_star_ts": 1701538964
          }
        },
        "3": {
          "1": {
            "star_index": 1040269,
            "get_star_ts": 1701742022
          },
          "2": {
            "get_star_ts": 1701920888,
            "star_index": 1468973
          }
        },
        "4": {
          "1": {
            "star_index": 1471275,
            "get_star_ts": 1701923781
          },
          "2": {
            "get_star_ts": 1702151038,
            "star_index": 1957624
          }
        }
      }
    },
    "621633": {
      "stars": 0,
      "global_score": 0,
      "last_star_ts": 0,
      "local_score": 0,
      "id": 621633,
      "name": "Carrie Flaspohler",
      "completion_day_level": {}
    },
    "621663": {
      "stars": 5,
      "global_score": 0,
      "id": 621663,
      "last_star_ts": 1702064509,
      "local_score": 316,
      "name": "Rachel Lieberman",
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 954695,
            "get_star_ts": 1701710865
          },
          "2": {
            "get_star_ts": 1701807940,
            "star_index": 1200372
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701804481,
            "star_index": 1190658
          },
          "2": {
            "star_index": 1192675,
            "get_star_ts": 1701805210
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1702064509,
            "star_index": 1787287
          }
        }
      }
    },
    "621765": {
      "stars": 9,
      "global_score": 0,
      "name": "brandon-myers-009",
      "last_star_ts": 1704750751,
      "id": 621765,
      "local_score": 530,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 1571227,
            "get_star_ts": 1701963074
          },
          "2": {
            "star_index": 3486431,
            "get_star_ts": 1704434737
          }
        },
        "2": {
          "1": {
            "star_index": 3486641,
            "get_star_ts": 1704438343
          },
          "2": {
            "get_star_ts": 1704600494,
            "star_index": 3504016
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1704611056,
            "star_index": 3504584
          },
          "2": {
            "get_star_ts": 1704611880,
            "star_index": 3504633
          }
        },
        "4": {
          "1": {
            "star_index": 3512010,
            "get_star_ts": 1704683285
          },
          "2": {
            "star_index": 3512412,
            "get_star_ts": 1704691245
          }
        },
        "5": {
          "1": {
            "star_index": 3518381,
            "get_star_ts": 1704750751
          }
        }
      }
    },
    "623312": {
      "global_score": 0,
      "stars": 3,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 135055,
            "get_star_ts": 1701443203
          },
          "2": {
            "star_index": 150063,
            "get_star_ts": 1701446873
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701876770,
            "star_index": 1383892
          }
        }
      },
      "last_star_ts": 1701876770,
      "local_score": 263,
      "id": 623312,
      "name": "dickiesanders"
    },
    "807471": {
      "name": "jonesg504",
      "last_star_ts": 1701541535,
      "id": 807471,
      "local_score": 63,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701541535,
            "star_index": 454850
          }
        }
      },
      "stars": 1,
      "global_score": 0
    },
    "846455": {
      "stars": 7,
      "global_score": 0,
      "last_star_ts": 1701739396,
      "local_score": 549,
      "id": 846455,
      "name": "Barrett Whetstone",
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701532556,
            "star_index": 423415
          },
          "2": {
            "get_star_ts": 1701663873,
            "star_index": 768165
          }
        },
        "2": {
          "1": {
            "star_index": 798764,
            "get_star_ts": 1701670041
          },
          "2": {
            "star_index": 803647,
            "get_star_ts": 1701671287
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1701675921,
            "star_index": 821199
          },
          "2": {
            "get_star_ts": 1701676780,
            "star_index": 824727
          }
        },
        "4": {
          "1": {
            "star_index": 1037063,
            "get_star_ts": 1701739396
          }
        }
      }
    },
    "953447": {
      "name": "Austin Leal",
      "id": 953447,
      "last_star_ts": 1705095347,
      "local_score": 3903,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701407350,
            "star_index": 3754
          },
          "2": {
            "get_star_ts": 1701408140,
            "star_index": 9797
          }
        },
        "2": {
          "1": {
            "star_index": 379204,
            "get_star_ts": 1701520533
          },
          "2": {
            "star_index": 383078,
            "get_star_ts": 1701521571
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1701613894,
            "star_index": 642204
          },
          "2": {
            "get_star_ts": 1701637540,
            "star_index": 720343
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1701691815,
            "star_index": 884381
          },
          "2": {
            "get_star_ts": 1701693415,
            "star_index": 890029
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1701780451,
            "star_index": 1127104
          },
          "2": {
            "star_index": 1202873,
            "get_star_ts": 1701808794
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1701865223,
            "star_index": 1351996
          },
          "2": {
            "star_index": 1352334,
            "get_star_ts": 1701865346
          }
        },
        "7": {
          "1": {
            "star_index": 1554475,
            "get_star_ts": 1701956099
          },
          "2": {
            "get_star_ts": 1701960728,
            "star_index": 1565518
          }
        },
        "8": {
          "1": {
            "star_index": 1730210,
            "get_star_ts": 1702038709
          },
          "2": {
            "star_index": 1823847,
            "get_star_ts": 1702091637
          }
        },
        "9": {
          "1": {
            "star_index": 1900784,
            "get_star_ts": 1702124705
          },
          "2": {
            "get_star_ts": 1702125026,
            "star_index": 1901508
          }
        },
        "10": {
          "1": {
            "star_index": 2051704,
            "get_star_ts": 1702215367
          },
          "2": {
            "get_star_ts": 1702226842,
            "star_index": 2074402
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1702298188,
            "star_index": 2196233
          },
          "2": {
            "get_star_ts": 1702298289,
            "star_index": 2196428
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1702385098,
            "star_index": 2320319
          },
          "2": {
            "star_index": 2374071,
            "get_star_ts": 1702425033
          }
        },
        "13": {
          "1": {
            "star_index": 2427221,
            "get_star_ts": 1702471209
          },
          "2": {
            "get_star_ts": 1702473602,
            "star_index": 2430367
          }
        },
        "14": {
          "1": {
            "star_index": 2531320,
            "get_star_ts": 1702557500
          },
          "2": {
            "star_index": 2569347,
            "get_star_ts": 1702589248
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1702642510,
            "star_index": 2636065
          },
          "2": {
            "get_star_ts": 1702651519,
            "star_index": 2648549
          }
        },
        "16": {
          "1": {
            "star_index": 2730798,
            "get_star_ts": 1702731701
          },
          "2": {
            "get_star_ts": 1702733497,
            "star_index": 2733054
          }
        },
        "19": {
          "1": {
            "get_star_ts": 1704977489,
            "star_index": 3536375
          }
        },
        "21": {
          "1": {
            "get_star_ts": 1705065563,
            "star_index": 3542469
          }
        },
        "23": {
          "1": {
            "star_index": 3545162,
            "get_star_ts": 1705095347
          }
        }
      },
      "stars": 35,
      "global_score": 0
    },
    "953450": {
      "stars": 36,
      "global_score": 0,
      "local_score": 3633,
      "last_star_ts": 1703203636,
      "id": 953450,
      "name": "Edd Purcell",
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 179201,
            "get_star_ts": 1701454466
          },
          "2": {
            "star_index": 191312,
            "get_star_ts": 1701458014
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701538351,
            "star_index": 444286
          },
          "2": {
            "star_index": 447582,
            "get_star_ts": 1701539317
          }
        },
        "3": {
          "1": {
            "star_index": 735410,
            "get_star_ts": 1701642350
          },
          "2": {
            "star_index": 743660,
            "get_star_ts": 1701645690
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1701700897,
            "star_index": 917634
          },
          "2": {
            "get_star_ts": 1701704052,
            "star_index": 929513
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1701830805,
            "star_index": 1244511
          },
          "2": {
            "get_star_ts": 1701889696,
            "star_index": 1416765
          }
        },
        "6": {
          "1": {
            "star_index": 1430581,
            "get_star_ts": 1701895071
          },
          "2": {
            "get_star_ts": 1701896508,
            "star_index": 1434227
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1702057552,
            "star_index": 1774082
          },
          "2": {
            "star_index": 1783718,
            "get_star_ts": 1702062612
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1702063920,
            "star_index": 1786197
          },
          "2": {
            "get_star_ts": 1702065255,
            "star_index": 1788806
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1702152732,
            "star_index": 1960872
          },
          "2": {
            "get_star_ts": 1702153063,
            "star_index": 1961496
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1702320745,
            "star_index": 2237931
          },
          "2": {
            "star_index": 2455248,
            "get_star_ts": 1702492798
          }
        },
        "11": {
          "1": {
            "star_index": 2278494,
            "get_star_ts": 1702351452
          },
          "2": {
            "get_star_ts": 1702351837,
            "star_index": 2278754
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1702752031,
            "star_index": 2755471
          },
          "2": {
            "get_star_ts": 1702777367,
            "star_index": 2778853
          }
        },
        "13": {
          "1": {
            "star_index": 2668835,
            "get_star_ts": 1702668613
          },
          "2": {
            "get_star_ts": 1702677314,
            "star_index": 2678046
          }
        },
        "14": {
          "1": {
            "star_index": 2684002,
            "get_star_ts": 1702684071
          },
          "2": {
            "star_index": 2689306,
            "get_star_ts": 1702694998
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1702656754,
            "star_index": 2655901
          },
          "2": {
            "get_star_ts": 1702663037,
            "star_index": 2663308
          }
        },
        "16": {
          "1": {
            "get_star_ts": 1702923455,
            "star_index": 2910036
          },
          "2": {
            "star_index": 2910782,
            "get_star_ts": 1702924182
          }
        },
        "17": {
          "1": {
            "star_index": 3047310,
            "get_star_ts": 1703088077
          },
          "2": {
            "star_index": 3049376,
            "get_star_ts": 1703090412
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1703096336,
            "star_index": 3054205
          }
        },
        "19": {
          "1": {
            "get_star_ts": 1703203636,
            "star_index": 3133000
          }
        }
      }
    },
    "953508": {
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 1153272,
            "get_star_ts": 1701790422
          },
          "2": {
            "star_index": 1163961,
            "get_star_ts": 1701794368
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701796938,
            "star_index": 1170782
          },
          "2": {
            "star_index": 1172733,
            "get_star_ts": 1701797705
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1701868366,
            "star_index": 1360479
          },
          "2": {
            "get_star_ts": 1701868532,
            "star_index": 1360917
          }
        }
      },
      "last_star_ts": 1701868532,
      "id": 953508,
      "local_score": 462,
      "name": "Kendra B",
      "global_score": 0,
      "stars": 6
    },
    "953987": {
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701441668,
            "star_index": 128834
          },
          "2": {
            "star_index": 136233,
            "get_star_ts": 1701443485
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701691742,
            "star_index": 884141
          },
          "2": {
            "star_index": 943719,
            "get_star_ts": 1701707799
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1701744573,
            "star_index": 1043353
          },
          "2": {
            "get_star_ts": 1701747317,
            "star_index": 1046478
          }
        },
        "4": {
          "1": {
            "star_index": 1115573,
            "get_star_ts": 1701775492
          },
          "2": {
            "get_star_ts": 1701791357,
            "star_index": 1155788
          }
        },
        "5": {
          "1": {
            "star_index": 1236046,
            "get_star_ts": 1701823166
          },
          "2": {
            "star_index": 1353386,
            "get_star_ts": 1701865738
          }
        },
        "6": {
          "1": {
            "star_index": 1465996,
            "get_star_ts": 1701917372
          },
          "2": {
            "star_index": 1466161,
            "get_star_ts": 1701917550
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1701996770,
            "star_index": 1640999
          },
          "2": {
            "star_index": 1644083,
            "get_star_ts": 1702000407
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1702043582,
            "star_index": 1741413
          },
          "2": {
            "get_star_ts": 1702093699,
            "star_index": 1825181
          }
        },
        "9": {
          "1": {
            "star_index": 1900566,
            "get_star_ts": 1702124609
          },
          "2": {
            "star_index": 1906846,
            "get_star_ts": 1702127396
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1702295818,
            "star_index": 2192191
          },
          "2": {
            "star_index": 2278973,
            "get_star_ts": 1702352137
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1702427706,
            "star_index": 2376175
          },
          "2": {
            "get_star_ts": 1702427995,
            "star_index": 2376370
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1702498164,
            "star_index": 2461898
          },
          "2": {
            "star_index": 2634232,
            "get_star_ts": 1702641027
          }
        }
      },
      "name": "Alex Dykstra",
      "last_star_ts": 1702641027,
      "local_score": 2281,
      "id": 953987,
      "global_score": 0,
      "stars": 24
    },
    "985048": {
      "stars": 10,
      "global_score": 0,
      "name": "Benjamin Mokotoff",
      "last_star_ts": 1703695655,
      "local_score": 851,
      "id": 985048,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701529843,
            "star_index": 413563
          },
          "2": {
            "star_index": 500715,
            "get_star_ts": 1701556647
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701532816,
            "star_index": 424359
          },
          "2": {
            "get_star_ts": 1701553450,
            "star_index": 491824
          }
        },
        "4": {
          "1": {
            "star_index": 1026996,
            "get_star_ts": 1701732764
          }
        },
        "6": {
          "1": {
            "star_index": 1462291,
            "get_star_ts": 1701913277
          },
          "2": {
            "get_star_ts": 1701917841,
            "star_index": 1466405
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1702002170,
            "star_index": 1645496
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1703695655,
            "star_index": 3359953
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1703543929,
            "star_index": 3318101
          }
        }
      }
    },
    "1075669": {
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 246355,
            "get_star_ts": 1701476637
          },
          "2": {
            "get_star_ts": 1701476686,
            "star_index": 246437
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701639787,
            "star_index": 727714
          },
          "2": {
            "get_star_ts": 1701639849,
            "star_index": 727915
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1702123566,
            "star_index": 1898116
          },
          "2": {
            "star_index": 1900329,
            "get_star_ts": 1702124504
          }
        },
        "4": {
          "1": {
            "star_index": 1907932,
            "get_star_ts": 1702127888
          },
          "2": {
            "star_index": 1908493,
            "get_star_ts": 1702128158
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1702426943,
            "star_index": 2375638
          },
          "2": {
            "star_index": 2377265,
            "get_star_ts": 1702429319
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1702689790,
            "star_index": 2687203
          },
          "2": {
            "get_star_ts": 1702729640,
            "star_index": 2728280
          }
        }
      },
      "local_score": 922,
      "last_star_ts": 1702729640,
      "id": 1075669,
      "name": "Cliff Free",
      "global_score": 0,
      "stars": 12
    },
    "1079762": {
      "stars": 7,
      "global_score": 0,
      "name": "Barry Ervin",
      "last_star_ts": 1701878737,
      "local_score": 646,
      "id": 1079762,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701448311,
            "star_index": 155843
          },
          "2": {
            "star_index": 170552,
            "get_star_ts": 1701452072
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701522282,
            "star_index": 385707
          },
          "2": {
            "star_index": 387808,
            "get_star_ts": 1701522864
          }
        },
        "3": {
          "1": {
            "star_index": 947925,
            "get_star_ts": 1701708956
          },
          "2": {
            "get_star_ts": 1701876644,
            "star_index": 1383561
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1701878737,
            "star_index": 1389191
          }
        }
      }
    },
    "1128251": {
      "global_score": 0,
      "stars": 1,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1702352138,
            "star_index": 2278975
          }
        }
      },
      "name": "Jelena Fordella",
      "id": 1128251,
      "last_star_ts": 1702352138,
      "local_score": 40
    },
    "1131015": {
      "global_score": 0,
      "stars": 13,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701657657,
            "star_index": 761173
          },
          "2": {
            "star_index": 766284,
            "get_star_ts": 1701662106
          }
        },
        "2": {
          "1": {
            "star_index": 768005,
            "get_star_ts": 1701663725
          },
          "2": {
            "get_star_ts": 1701664608,
            "star_index": 768951
          }
        },
        "3": {
          "1": {
            "star_index": 941867,
            "get_star_ts": 1701707304
          },
          "2": {
            "star_index": 945734,
            "get_star_ts": 1701708364
          }
        },
        "4": {
          "1": {
            "star_index": 953323,
            "get_star_ts": 1701710486
          },
          "2": {
            "get_star_ts": 1701715680,
            "star_index": 971626
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1701807600,
            "star_index": 1199404
          },
          "2": {
            "get_star_ts": 1701809695,
            "star_index": 1205563
          }
        },
        "6": {
          "1": {
            "star_index": 1275985,
            "get_star_ts": 1701841614
          },
          "2": {
            "star_index": 1277673,
            "get_star_ts": 1701842000
          }
        },
        "8": {
          "1": {
            "star_index": 2563766,
            "get_star_ts": 1702584592
          }
        }
      },
      "name": "ericpass",
      "local_score": 1166,
      "last_star_ts": 1702584592,
      "id": 1131015
    },
    "1287384": {
      "last_star_ts": 1703622541,
      "id": 1287384,
      "local_score": 4538,
      "name": "Mark Hirons",
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701407287,
            "star_index": 3134
          },
          "2": {
            "star_index": 132737,
            "get_star_ts": 1701442619
          }
        },
        "2": {
          "1": {
            "star_index": 429056,
            "get_star_ts": 1701534112
          },
          "2": {
            "get_star_ts": 1701534527,
            "star_index": 430559
          }
        },
        "3": {
          "1": {
            "star_index": 670192,
            "get_star_ts": 1701622421
          },
          "2": {
            "get_star_ts": 1701622962,
            "star_index": 672016
          }
        },
        "4": {
          "1": {
            "star_index": 904039,
            "get_star_ts": 1701697332
          },
          "2": {
            "get_star_ts": 1701699854,
            "star_index": 913645
          }
        },
        "5": {
          "1": {
            "star_index": 1236702,
            "get_star_ts": 1701823670
          },
          "2": {
            "star_index": 1386923,
            "get_star_ts": 1701877916
          }
        },
        "6": {
          "1": {
            "star_index": 1391228,
            "get_star_ts": 1701879504
          },
          "2": {
            "get_star_ts": 1701879825,
            "star_index": 1392057
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1701961482,
            "star_index": 1567376
          },
          "2": {
            "get_star_ts": 1701965062,
            "star_index": 1576108
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1702045792,
            "star_index": 1746760
          },
          "2": {
            "star_index": 1757577,
            "get_star_ts": 1702050177
          }
        },
        "9": {
          "1": {
            "star_index": 1926905,
            "get_star_ts": 1702136101
          },
          "2": {
            "star_index": 1928074,
            "get_star_ts": 1702136622
          }
        },
        "10": {
          "1": {
            "star_index": 2067897,
            "get_star_ts": 1702223678
          },
          "2": {
            "get_star_ts": 1702272412,
            "star_index": 2140689
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1702316093,
            "star_index": 2229752
          },
          "2": {
            "get_star_ts": 1702317929,
            "star_index": 2232916
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1702483322,
            "star_index": 2443470
          },
          "2": {
            "star_index": 2815704,
            "get_star_ts": 1702824901
          }
        },
        "13": {
          "1": {
            "star_index": 2453883,
            "get_star_ts": 1702491685
          },
          "2": {
            "star_index": 2460342,
            "get_star_ts": 1702497049
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1702590574,
            "star_index": 2570958
          },
          "2": {
            "star_index": 2585061,
            "get_star_ts": 1702612706
          }
        },
        "15": {
          "1": {
            "star_index": 2651790,
            "get_star_ts": 1702653711
          },
          "2": {
            "star_index": 2654850,
            "get_star_ts": 1702655883
          }
        },
        "16": {
          "1": {
            "star_index": 2747900,
            "get_star_ts": 1702745325
          },
          "2": {
            "star_index": 2749235,
            "get_star_ts": 1702746439
          }
        },
        "18": {
          "1": {
            "star_index": 2919163,
            "get_star_ts": 1702932067
          },
          "2": {
            "get_star_ts": 1702951290,
            "star_index": 2934210
          }
        },
        "19": {
          "1": {
            "star_index": 3000615,
            "get_star_ts": 1703022479
          },
          "2": {
            "star_index": 3013717,
            "get_star_ts": 1703047935
          }
        },
        "20": {
          "1": {
            "star_index": 3064909,
            "get_star_ts": 1703109003
          }
        },
        "21": {
          "1": {
            "star_index": 3131239,
            "get_star_ts": 1703200226
          }
        },
        "22": {
          "1": {
            "get_star_ts": 1703383277,
            "star_index": 3239753
          },
          "2": {
            "star_index": 3270319,
            "get_star_ts": 1703439984
          }
        },
        "23": {
          "1": {
            "get_star_ts": 1703442541,
            "star_index": 3271542
          }
        },
        "24": {
          "1": {
            "star_index": 3340822,
            "get_star_ts": 1703622541
          }
        }
      },
      "stars": 42,
      "global_score": 0
    },
    "1336133": {
      "stars": 2,
      "global_score": 0,
      "last_star_ts": 1701494161,
      "local_score": 143,
      "id": 1336133,
      "name": "Mahdi Albori",
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701488453,
            "star_index": 261741
          },
          "2": {
            "get_star_ts": 1701494161,
            "star_index": 272838
          }
        }
      }
    },
    "1491389": {
      "stars": 1,
      "global_score": 0,
      "last_star_ts": 1701437158,
      "id": 1491389,
      "local_score": 105,
      "name": "tomloizzo1",
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701437158,
            "star_index": 111521
          }
        }
      }
    },
    "1492817": {
      "stars": 26,
      "global_score": 0,
      "last_star_ts": 1703195835,
      "local_score": 2453,
      "id": 1492817,
      "name": "Kelly Tabler",
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701462568,
            "star_index": 206582
          },
          "2": {
            "get_star_ts": 1701469082,
            "star_index": 228045
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701537484,
            "star_index": 441298
          },
          "2": {
            "star_index": 442419,
            "get_star_ts": 1701537807
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1701637569,
            "star_index": 720438
          },
          "2": {
            "star_index": 729682,
            "get_star_ts": 1701640420
          }
        },
        "4": {
          "1": {
            "star_index": 1002909,
            "get_star_ts": 1701724346
          },
          "2": {
            "star_index": 1011213,
            "get_star_ts": 1701726800
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1701791249,
            "star_index": 1155484
          },
          "2": {
            "star_index": 1188013,
            "get_star_ts": 1701803510
          }
        },
        "6": {
          "1": {
            "star_index": 1458912,
            "get_star_ts": 1701909894
          },
          "2": {
            "star_index": 1459035,
            "get_star_ts": 1701910007
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1701973246,
            "star_index": 1594681
          },
          "2": {
            "get_star_ts": 1701974486,
            "star_index": 1597407
          }
        },
        "8": {
          "1": {
            "star_index": 2238349,
            "get_star_ts": 1702320965
          },
          "2": {
            "get_star_ts": 1702323506,
            "star_index": 2243036
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1702325530,
            "star_index": 2246995
          },
          "2": {
            "star_index": 2247527,
            "get_star_ts": 1702325813
          }
        },
        "10": {
          "1": {
            "star_index": 2443950,
            "get_star_ts": 1702483695
          },
          "2": {
            "star_index": 2444707,
            "get_star_ts": 1702484313
          }
        },
        "11": {
          "1": {
            "star_index": 3115215,
            "get_star_ts": 1703178869
          },
          "2": {
            "star_index": 3115344,
            "get_star_ts": 1703179037
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1703185085,
            "star_index": 3119869
          },
          "2": {
            "star_index": 3121052,
            "get_star_ts": 1703186755
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1703192478,
            "star_index": 3125591
          },
          "2": {
            "star_index": 3128201,
            "get_star_ts": 1703195835
          }
        }
      }
    },
    "1512095": {
      "global_score": 0,
      "stars": 43,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701433403,
            "star_index": 98829
          },
          "2": {
            "get_star_ts": 1701434611,
            "star_index": 102806
          }
        },
        "2": {
          "1": {
            "star_index": 398641,
            "get_star_ts": 1701525765
          },
          "2": {
            "get_star_ts": 1701525893,
            "star_index": 399119
          }
        },
        "3": {
          "1": {
            "star_index": 656407,
            "get_star_ts": 1701618257
          },
          "2": {
            "star_index": 658718,
            "get_star_ts": 1701618966
          }
        },
        "4": {
          "1": {
            "star_index": 886791,
            "get_star_ts": 1701692473
          },
          "2": {
            "get_star_ts": 1701693409,
            "star_index": 890012
          }
        },
        "5": {
          "1": {
            "star_index": 1127011,
            "get_star_ts": 1701780411
          },
          "2": {
            "star_index": 1157726,
            "get_star_ts": 1701792043
          }
        },
        "6": {
          "1": {
            "star_index": 1352817,
            "get_star_ts": 1701865535
          },
          "2": {
            "get_star_ts": 1701866118,
            "star_index": 1354357
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1701953903,
            "star_index": 1549393
          },
          "2": {
            "star_index": 1566453,
            "get_star_ts": 1701961092
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1702039076,
            "star_index": 1731033
          },
          "2": {
            "star_index": 1737868,
            "get_star_ts": 1702042106
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1702131454,
            "star_index": 1916084
          },
          "2": {
            "star_index": 1916438,
            "get_star_ts": 1702131586
          }
        },
        "10": {
          "1": {
            "star_index": 2060059,
            "get_star_ts": 1702219719
          },
          "2": {
            "star_index": 2116310,
            "get_star_ts": 1702248681
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1702297795,
            "star_index": 2195587
          },
          "2": {
            "star_index": 2197608,
            "get_star_ts": 1702298959
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1702393986,
            "star_index": 2331948
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1702474725,
            "star_index": 2431817
          },
          "2": {
            "get_star_ts": 1702488001,
            "star_index": 2449428
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1702531746,
            "star_index": 2493544
          },
          "2": {
            "get_star_ts": 1702537512,
            "star_index": 2504769
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1702643153,
            "star_index": 2636885
          },
          "2": {
            "star_index": 2639396,
            "get_star_ts": 1702644983
          }
        },
        "16": {
          "1": {
            "star_index": 2839453,
            "get_star_ts": 1702847069
          },
          "2": {
            "star_index": 2843841,
            "get_star_ts": 1702851058
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1702904264,
            "star_index": 2889443
          },
          "2": {
            "star_index": 2898817,
            "get_star_ts": 1702912998
          }
        },
        "19": {
          "1": {
            "star_index": 2970928,
            "get_star_ts": 1702992038
          },
          "2": {
            "get_star_ts": 1703016687,
            "star_index": 2994828
          }
        },
        "20": {
          "1": {
            "star_index": 3039801,
            "get_star_ts": 1703079683
          },
          "2": {
            "star_index": 3043584,
            "get_star_ts": 1703084051
          }
        },
        "21": {
          "1": {
            "get_star_ts": 1703164257,
            "star_index": 3103450
          },
          "2": {
            "get_star_ts": 1703193294,
            "star_index": 3126251
          }
        },
        "22": {
          "1": {
            "star_index": 3179960,
            "get_star_ts": 1703278343
          },
          "2": {
            "get_star_ts": 1704142032,
            "star_index": 3446434
          }
        },
        "23": {
          "1": {
            "star_index": 3457178,
            "get_star_ts": 1704215865
          }
        },
        "24": {
          "1": {
            "get_star_ts": 1704380758,
            "star_index": 3479562
          }
        }
      },
      "name": "Mike Eilbacher",
      "last_star_ts": 1704380758,
      "id": 1512095,
      "local_score": 4845
    },
    "1513819": {
      "global_score": 0,
      "stars": 36,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 223883,
            "get_star_ts": 1701467786
          },
          "2": {
            "get_star_ts": 1701480593,
            "star_index": 252423
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701540183,
            "star_index": 450470
          },
          "2": {
            "star_index": 451008,
            "get_star_ts": 1701540345
          }
        },
        "3": {
          "1": {
            "star_index": 1042570,
            "get_star_ts": 1701743958
          },
          "2": {
            "star_index": 1145731,
            "get_star_ts": 1701787658
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1701747138,
            "star_index": 1046266
          },
          "2": {
            "star_index": 1051598,
            "get_star_ts": 1701752148
          }
        },
        "5": {
          "1": {
            "star_index": 1427669,
            "get_star_ts": 1701893942
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1702068007,
            "star_index": 1794237
          },
          "2": {
            "get_star_ts": 1702068477,
            "star_index": 1795136
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1702070445,
            "star_index": 1798929
          },
          "2": {
            "get_star_ts": 1702071633,
            "star_index": 1801205
          }
        },
        "8": {
          "1": {
            "star_index": 1790872,
            "get_star_ts": 1702066294
          },
          "2": {
            "get_star_ts": 1702067127,
            "star_index": 1792487
          }
        },
        "9": {
          "1": {
            "star_index": 1928568,
            "get_star_ts": 1702136839
          },
          "2": {
            "star_index": 1929146,
            "get_star_ts": 1702137101
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1702239036,
            "star_index": 2098270
          },
          "2": {
            "get_star_ts": 1702262893,
            "star_index": 2129839
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1702348082,
            "star_index": 2276161
          },
          "2": {
            "get_star_ts": 1702349234,
            "star_index": 2276985
          }
        },
        "12": {
          "1": {
            "star_index": 2345642,
            "get_star_ts": 1702403959
          },
          "2": {
            "get_star_ts": 1702434623,
            "star_index": 2380295
          }
        },
        "13": {
          "1": {
            "star_index": 2482828,
            "get_star_ts": 1702519776
          },
          "2": {
            "star_index": 2484040,
            "get_star_ts": 1702522171
          }
        },
        "14": {
          "1": {
            "star_index": 2760594,
            "get_star_ts": 1702756794
          }
        },
        "15": {
          "1": {
            "star_index": 2934146,
            "get_star_ts": 1702951118
          },
          "2": {
            "get_star_ts": 1702952297,
            "star_index": 2934637
          }
        },
        "16": {
          "1": {
            "star_index": 2936120,
            "get_star_ts": 1702956057
          },
          "2": {
            "star_index": 2936990,
            "get_star_ts": 1702958324
          }
        },
        "18": {
          "1": {
            "star_index": 3010801,
            "get_star_ts": 1703039712
          },
          "2": {
            "get_star_ts": 1703041614,
            "star_index": 3011526
          }
        },
        "19": {
          "1": {
            "star_index": 3191819,
            "get_star_ts": 1703304222
          }
        },
        "21": {
          "1": {
            "star_index": 3240446,
            "get_star_ts": 1703385768
          }
        },
        "23": {
          "1": {
            "get_star_ts": 1703447232,
            "star_index": 3273723
          }
        },
        "24": {
          "1": {
            "get_star_ts": 1703476837,
            "star_index": 3284101
          }
        }
      },
      "last_star_ts": 1703476837,
      "id": 1513819,
      "local_score": 3541,
      "name": "Patrick Clements"
    },
    "1543143": {
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 209482,
            "get_star_ts": 1701463432
          },
          "2": {
            "star_index": 219956,
            "get_star_ts": 1701466572
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701531585,
            "star_index": 419841
          },
          "2": {
            "star_index": 422389,
            "get_star_ts": 1701532267
          }
        },
        "3": {
          "1": {
            "star_index": 753735,
            "get_star_ts": 1701651572
          },
          "2": {
            "get_star_ts": 1701658172,
            "star_index": 761820
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1701705068,
            "star_index": 933354
          },
          "2": {
            "star_index": 1182598,
            "get_star_ts": 1701801471
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1704903102,
            "star_index": 3531179
          },
          "2": {
            "star_index": 3531421,
            "get_star_ts": 1704905203
          }
        }
      },
      "name": "Dave Barrett",
      "last_star_ts": 1704905203,
      "id": 1543143,
      "local_score": 882,
      "global_score": 0,
      "stars": 10
    },
    "1550722": {
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701448348,
            "star_index": 156001
          },
          "2": {
            "star_index": 159696,
            "get_star_ts": 1701449273
          }
        },
        "2": {
          "1": {
            "star_index": 278969,
            "get_star_ts": 1701494808
          },
          "2": {
            "get_star_ts": 1701495343,
            "star_index": 283176
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1701655102,
            "star_index": 758211
          },
          "2": {
            "get_star_ts": 1701737181,
            "star_index": 1034221
          }
        },
        "4": {
          "1": {
            "star_index": 930074,
            "get_star_ts": 1701704209
          },
          "2": {
            "get_star_ts": 1701734485,
            "star_index": 1030144
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1701826451,
            "star_index": 1239939
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1702092017,
            "star_index": 1824075
          }
        }
      },
      "name": "Anfer",
      "last_star_ts": 1702092017,
      "id": 1550722,
      "local_score": 972,
      "global_score": 0,
      "stars": 10
    },
    "1551553": {
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701408365,
            "star_index": 11073
          },
          "2": {
            "star_index": 30041,
            "get_star_ts": 1701413977
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701497881,
            "star_index": 295779
          },
          "2": {
            "star_index": 299179,
            "get_star_ts": 1701498852
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1701701421,
            "star_index": 919627
          },
          "2": {
            "get_star_ts": 1701721718,
            "star_index": 993284
          }
        },
        "4": {
          "1": {
            "star_index": 949795,
            "get_star_ts": 1701709461
          },
          "2": {
            "get_star_ts": 1701713020,
            "star_index": 962324
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1701756610,
            "star_index": 1066005
          },
          "2": {
            "get_star_ts": 1701807556,
            "star_index": 1199280
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1701839484,
            "star_index": 1257945
          },
          "2": {
            "star_index": 1261371,
            "get_star_ts": 1701839725
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1701933225,
            "star_index": 1498732
          },
          "2": {
            "star_index": 1504304,
            "get_star_ts": 1701935430
          }
        },
        "8": {
          "1": {
            "star_index": 1790690,
            "get_star_ts": 1702066216
          },
          "2": {
            "get_star_ts": 1702140916,
            "star_index": 1937808
          }
        },
        "9": {
          "1": {
            "star_index": 2239362,
            "get_star_ts": 1702321514
          },
          "2": {
            "star_index": 2240096,
            "get_star_ts": 1702321940
          }
        },
        "11": {
          "1": {
            "star_index": 2359905,
            "get_star_ts": 1702414105
          },
          "2": {
            "star_index": 2361443,
            "get_star_ts": 1702415079
          }
        },
        "12": {
          "1": {
            "star_index": 2484890,
            "get_star_ts": 1702523879
          },
          "2": {
            "get_star_ts": 1702526713,
            "star_index": 2486260
          }
        },
        "14": {
          "1": {
            "star_index": 2543442,
            "get_star_ts": 1702566974
          },
          "2": {
            "star_index": 2656680,
            "get_star_ts": 1702657301
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1702659106,
            "star_index": 2658863
          },
          "2": {
            "get_star_ts": 1702675308,
            "star_index": 2675896
          }
        }
      },
      "local_score": 2723,
      "last_star_ts": 1702675308,
      "id": 1551553,
      "name": "Drew Teachout",
      "global_score": 0,
      "stars": 26
    },
    "1551779": {
      "global_score": 0,
      "stars": 10,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701443347,
            "star_index": 135657
          },
          "2": {
            "star_index": 170230,
            "get_star_ts": 1701451985
          }
        },
        "2": {
          "1": {
            "star_index": 2435403,
            "get_star_ts": 1702477470
          },
          "2": {
            "get_star_ts": 1702477847,
            "star_index": 2435951
          }
        },
        "4": {
          "1": {
            "star_index": 2438234,
            "get_star_ts": 1702479508
          },
          "2": {
            "star_index": 2440370,
            "get_star_ts": 1702481088
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1702674855,
            "star_index": 2675391
          },
          "2": {
            "get_star_ts": 1702674961,
            "star_index": 2675508
          }
        },
        "15": {
          "1": {
            "star_index": 3544725,
            "get_star_ts": 1705090507
          },
          "2": {
            "star_index": 3544955,
            "get_star_ts": 1705093239
          }
        }
      },
      "last_star_ts": 1705093239,
      "local_score": 773,
      "id": 1551779,
      "name": "Graham Guthrie"
    },
    "1552420": {
      "name": "Dina Zhang",
      "last_star_ts": 1703888335,
      "local_score": 1579,
      "id": 1552420,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 165413,
            "get_star_ts": 1701450718
          },
          "2": {
            "star_index": 184919,
            "get_star_ts": 1701456096
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701495180,
            "star_index": 281992
          },
          "2": {
            "get_star_ts": 1701496907,
            "star_index": 291874
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1701621558,
            "star_index": 667285
          },
          "2": {
            "star_index": 678489,
            "get_star_ts": 1701624882
          }
        },
        "4": {
          "1": {
            "star_index": 1041850,
            "get_star_ts": 1701743331
          },
          "2": {
            "get_star_ts": 1701747597,
            "star_index": 1046805
          }
        },
        "5": {
          "1": {
            "star_index": 1068196,
            "get_star_ts": 1701757300
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1702250514,
            "star_index": 2118966
          },
          "2": {
            "get_star_ts": 1702251173,
            "star_index": 2119786
          }
        },
        "7": {
          "1": {
            "star_index": 2272746,
            "get_star_ts": 1702343030
          },
          "2": {
            "get_star_ts": 1702365704,
            "star_index": 2296143
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1703882916,
            "star_index": 3406495
          },
          "2": {
            "get_star_ts": 1703884465,
            "star_index": 3406937
          }
        },
        "9": {
          "1": {
            "star_index": 3407992,
            "get_star_ts": 1703888110
          },
          "2": {
            "star_index": 3408061,
            "get_star_ts": 1703888335
          }
        }
      },
      "stars": 17,
      "global_score": 0
    },
    "1552821": {
      "global_score": 0,
      "stars": 0,
      "completion_day_level": {},
      "name": "Lily Li",
      "local_score": 0,
      "last_star_ts": 0,
      "id": 1552821
    },
    "1552913": {
      "global_score": 0,
      "stars": 0,
      "completion_day_level": {},
      "name": "Jules Scheil",
      "local_score": 0,
      "last_star_ts": 0,
      "id": 1552913
    },
    "1554163": {
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 112195,
            "get_star_ts": 1701437346
          },
          "2": {
            "get_star_ts": 1701438537,
            "star_index": 116582
          }
        }
      },
      "name": "dtewell19",
      "last_star_ts": 1701438537,
      "id": 1554163,
      "local_score": 214,
      "global_score": 0,
      "stars": 2
    },
    "1554509": {
      "global_score": 0,
      "stars": 0,
      "completion_day_level": {},
      "last_star_ts": 0,
      "id": 1554509,
      "local_score": 0,
      "name": "Gunnar Martin"
    },
    "1554651": {
      "global_score": 0,
      "stars": 24,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701441445,
            "star_index": 127940
          },
          "2": {
            "get_star_ts": 1701451931,
            "star_index": 170037
          }
        },
        "2": {
          "1": {
            "star_index": 415578,
            "get_star_ts": 1701530389
          },
          "2": {
            "star_index": 418113,
            "get_star_ts": 1701531081
          }
        },
        "3": {
          "1": {
            "star_index": 751547,
            "get_star_ts": 1701650000
          },
          "2": {
            "get_star_ts": 1701653106,
            "star_index": 755721
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1701705402,
            "star_index": 934622
          },
          "2": {
            "get_star_ts": 1701708479,
            "star_index": 946146
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1701838331,
            "star_index": 1252048
          },
          "2": {
            "star_index": 1458811,
            "get_star_ts": 1701909799
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1701923327,
            "star_index": 1470931
          },
          "2": {
            "get_star_ts": 1701923411,
            "star_index": 1470995
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1701981773,
            "star_index": 1614046
          },
          "2": {
            "star_index": 1625019,
            "get_star_ts": 1701986486
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1702049936,
            "star_index": 1757012
          },
          "2": {
            "star_index": 1793554,
            "get_star_ts": 1702067652
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1702140093,
            "star_index": 1936049
          },
          "2": {
            "get_star_ts": 1702141206,
            "star_index": 1938419
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1702313512,
            "star_index": 2225169
          },
          "2": {
            "star_index": 2239592,
            "get_star_ts": 1702321660
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1702357796,
            "star_index": 2282636
          },
          "2": {
            "star_index": 2291062,
            "get_star_ts": 1702361941
          }
        },
        "12": {
          "1": {
            "star_index": 2394780,
            "get_star_ts": 1702447634
          }
        },
        "13": {
          "1": {
            "star_index": 2495716,
            "get_star_ts": 1702532467
          }
        }
      },
      "last_star_ts": 1702532467,
      "id": 1554651,
      "local_score": 2381,
      "name": "Aidan Murphy"
    },
    "1561945": {
      "global_score": 0,
      "stars": 12,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701457968,
            "star_index": 191156
          },
          "2": {
            "get_star_ts": 1701462521,
            "star_index": 206424
          }
        },
        "2": {
          "1": {
            "star_index": 449512,
            "get_star_ts": 1701539902
          },
          "2": {
            "star_index": 457798,
            "get_star_ts": 1701542448
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1701744761,
            "star_index": 1043574
          },
          "2": {
            "get_star_ts": 1701834925,
            "star_index": 1248779
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1701822938,
            "star_index": 1235755
          },
          "2": {
            "get_star_ts": 1701829456,
            "star_index": 1243077
          }
        },
        "6": {
          "1": {
            "star_index": 1466674,
            "get_star_ts": 1701918136
          },
          "2": {
            "star_index": 1466737,
            "get_star_ts": 1701918208
          }
        },
        "7": {
          "1": {
            "star_index": 3135064,
            "get_star_ts": 1703209133
          },
          "2": {
            "get_star_ts": 1703214706,
            "star_index": 3136769
          }
        }
      },
      "last_star_ts": 1703214706,
      "id": 1561945,
      "local_score": 1007,
      "name": "llbarnet"
    },
    "1562745": {
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 230613,
            "get_star_ts": 1701469948
          },
          "2": {
            "star_index": 248429,
            "get_star_ts": 1701477884
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701544815,
            "star_index": 465203
          },
          "2": {
            "get_star_ts": 1701554191,
            "star_index": 493929
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1701644393,
            "star_index": 740742
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1701729448,
            "star_index": 1019286
          },
          "2": {
            "star_index": 1039086,
            "get_star_ts": 1701741052
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1702077961,
            "star_index": 1811666
          }
        }
      },
      "last_star_ts": 1702077961,
      "local_score": 693,
      "id": 1562745,
      "name": "Stephen Ilhardt",
      "global_score": 0,
      "stars": 8
    },
    "1563197": {
      "stars": 2,
      "global_score": 0,
      "name": "Steven French",
      "local_score": 110,
      "last_star_ts": 1701798432,
      "id": 1563197,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 1002566,
            "get_star_ts": 1701724257
          },
          "2": {
            "star_index": 1174617,
            "get_star_ts": 1701798432
          }
        }
      }
    },
    "1636057": {
      "stars": 43,
      "global_score": 0,
      "id": 1636057,
      "last_star_ts": 1703802467,
      "local_score": 4116,
      "name": "Jordan Leahey",
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701720636,
            "star_index": 989292
          },
          "2": {
            "star_index": 1026594,
            "get_star_ts": 1701732565
          }
        },
        "2": {
          "1": {
            "star_index": 1030645,
            "get_star_ts": 1701734780
          },
          "2": {
            "star_index": 1032456,
            "get_star_ts": 1701735938
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1701799221,
            "star_index": 1176708
          },
          "2": {
            "get_star_ts": 1701898471,
            "star_index": 1439213
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1701957404,
            "star_index": 1557622
          },
          "2": {
            "get_star_ts": 1701960458,
            "star_index": 1564884
          }
        },
        "5": {
          "1": {
            "star_index": 1599173,
            "get_star_ts": 1701975291
          },
          "2": {
            "star_index": 1641977,
            "get_star_ts": 1701997837
          }
        },
        "6": {
          "1": {
            "star_index": 1643161,
            "get_star_ts": 1701999214
          },
          "2": {
            "get_star_ts": 1701999476,
            "star_index": 1643380
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1702051663,
            "star_index": 1761145
          },
          "2": {
            "star_index": 1766890,
            "get_star_ts": 1702054172
          }
        },
        "8": {
          "1": {
            "star_index": 1782435,
            "get_star_ts": 1702061922
          },
          "2": {
            "star_index": 1800777,
            "get_star_ts": 1702071403
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1702145250,
            "star_index": 1946732
          },
          "2": {
            "star_index": 1947392,
            "get_star_ts": 1702145582
          }
        },
        "10": {
          "1": {
            "star_index": 2117634,
            "get_star_ts": 1702249583
          },
          "2": {
            "get_star_ts": 1702410450,
            "star_index": 2354450
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1702423826,
            "star_index": 2372996
          },
          "2": {
            "get_star_ts": 1702426287,
            "star_index": 2375091
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1702569622,
            "star_index": 2546869
          },
          "2": {
            "get_star_ts": 1702752791,
            "star_index": 2756293
          }
        },
        "13": {
          "1": {
            "star_index": 2767578,
            "get_star_ts": 1702763033
          },
          "2": {
            "star_index": 2841405,
            "get_star_ts": 1702848818
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1702911740,
            "star_index": 2897422
          },
          "2": {
            "get_star_ts": 1702924085,
            "star_index": 2910685
          }
        },
        "15": {
          "1": {
            "star_index": 2913450,
            "get_star_ts": 1702926789
          },
          "2": {
            "get_star_ts": 1702930091,
            "star_index": 2916966
          }
        },
        "16": {
          "1": {
            "star_index": 2925397,
            "get_star_ts": 1702937644
          },
          "2": {
            "get_star_ts": 1702938283,
            "star_index": 2926041
          }
        },
        "17": {
          "1": {
            "get_star_ts": 1703387406,
            "star_index": 3240906
          },
          "2": {
            "get_star_ts": 1703392962,
            "star_index": 3242197
          }
        },
        "18": {
          "1": {
            "star_index": 3262868,
            "get_star_ts": 1703426896
          },
          "2": {
            "star_index": 3263182,
            "get_star_ts": 1703427419
          }
        },
        "19": {
          "1": {
            "star_index": 3266075,
            "get_star_ts": 1703432192
          },
          "2": {
            "get_star_ts": 1703608080,
            "star_index": 3335196
          }
        },
        "20": {
          "1": {
            "get_star_ts": 1703644424,
            "star_index": 3347727
          },
          "2": {
            "star_index": 3356413,
            "get_star_ts": 1703686215
          }
        },
        "21": {
          "1": {
            "star_index": 3358241,
            "get_star_ts": 1703691106
          },
          "2": {
            "star_index": 3364783,
            "get_star_ts": 1703709006
          }
        },
        "23": {
          "1": {
            "get_star_ts": 1703802467,
            "star_index": 3389130
          }
        }
      }
    },
    "1695980": {
      "stars": 12,
      "global_score": 0,
      "local_score": 761,
      "last_star_ts": 1705291227,
      "id": 1695980,
      "name": "Miriam L",
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 3482582,
            "get_star_ts": 1704399682
          },
          "2": {
            "star_index": 3482722,
            "get_star_ts": 1704400679
          }
        },
        "2": {
          "1": {
            "star_index": 3483419,
            "get_star_ts": 1704405023
          },
          "2": {
            "get_star_ts": 1704407194,
            "star_index": 3483751
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1705291227,
            "star_index": 3557852
          }
        },
        "4": {
          "1": {
            "star_index": 3484057,
            "get_star_ts": 1704408664
          },
          "2": {
            "get_star_ts": 1704409842,
            "star_index": 3484275
          }
        },
        "5": {
          "1": {
            "star_index": 3552045,
            "get_star_ts": 1705194641
          },
          "2": {
            "get_star_ts": 1705194660,
            "star_index": 3552046
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1705194907,
            "star_index": 3552060
          }
        },
        "7": {
          "1": {
            "star_index": 3552161,
            "get_star_ts": 1705197846
          },
          "2": {
            "get_star_ts": 1705198606,
            "star_index": 3552190
          }
        }
      }
    },
    "1946955": {
      "name": "Foster Gorman",
      "local_score": 2343,
      "last_star_ts": 1702401532,
      "id": 1946955,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 99149,
            "get_star_ts": 1701433501
          },
          "2": {
            "star_index": 125615,
            "get_star_ts": 1701440875
          }
        },
        "2": {
          "1": {
            "star_index": 384551,
            "get_star_ts": 1701521969
          },
          "2": {
            "star_index": 387384,
            "get_star_ts": 1701522745
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1701611863,
            "star_index": 635669
          },
          "2": {
            "star_index": 893486,
            "get_star_ts": 1701694393
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1701697462,
            "star_index": 904568
          },
          "2": {
            "star_index": 931535,
            "get_star_ts": 1701704596
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1701783940,
            "star_index": 1136028
          },
          "2": {
            "star_index": 1179460,
            "get_star_ts": 1701800273
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1701869176,
            "star_index": 1362689
          },
          "2": {
            "get_star_ts": 1701869596,
            "star_index": 1363810
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1701959598,
            "star_index": 1562837
          },
          "2": {
            "get_star_ts": 1701980577,
            "star_index": 1611189
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1702045132,
            "star_index": 1745116
          },
          "2": {
            "star_index": 1751155,
            "get_star_ts": 1702047540
          }
        },
        "9": {
          "1": {
            "star_index": 1906944,
            "get_star_ts": 1702127443
          },
          "2": {
            "star_index": 1908473,
            "get_star_ts": 1702128140
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1702240754,
            "star_index": 2101727
          },
          "2": {
            "get_star_ts": 1702401532,
            "star_index": 2342559
          }
        },
        "11": {
          "1": {
            "star_index": 2224885,
            "get_star_ts": 1702313378
          },
          "2": {
            "star_index": 2228839,
            "get_star_ts": 1702315568
          }
        }
      },
      "stars": 22,
      "global_score": 0
    },
    "1957456": {
      "name": "cbalusekslalom",
      "last_star_ts": 1704615865,
      "id": 1957456,
      "local_score": 2239,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701447374,
            "star_index": 152080
          },
          "2": {
            "star_index": 220924,
            "get_star_ts": 1701466874
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701548282,
            "star_index": 476156
          },
          "2": {
            "get_star_ts": 1701548556,
            "star_index": 476990
          }
        },
        "4": {
          "1": {
            "star_index": 938297,
            "get_star_ts": 1701706367
          },
          "2": {
            "star_index": 1019679,
            "get_star_ts": 1701729602
          }
        },
        "5": {
          "1": {
            "star_index": 1272582,
            "get_star_ts": 1701840961
          },
          "2": {
            "get_star_ts": 1701881697,
            "star_index": 1397040
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1701843213,
            "star_index": 1282003
          },
          "2": {
            "get_star_ts": 1701843294,
            "star_index": 1282276
          }
        },
        "7": {
          "1": {
            "star_index": 1490561,
            "get_star_ts": 1701930301
          },
          "2": {
            "get_star_ts": 1702104498,
            "star_index": 1853143
          }
        },
        "8": {
          "1": {
            "star_index": 1662409,
            "get_star_ts": 1702013193
          },
          "2": {
            "get_star_ts": 1702103511,
            "star_index": 1851064
          }
        },
        "9": {
          "1": {
            "star_index": 1854262,
            "get_star_ts": 1702105089
          },
          "2": {
            "star_index": 1855515,
            "get_star_ts": 1702105732
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1704566227,
            "star_index": 3500421
          },
          "2": {
            "get_star_ts": 1704568524,
            "star_index": 3500721
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1704603136,
            "star_index": 3504163
          }
        },
        "14": {
          "1": {
            "star_index": 3504395,
            "get_star_ts": 1704607626
          },
          "2": {
            "get_star_ts": 1704613365,
            "star_index": 3504706
          }
        },
        "15": {
          "1": {
            "star_index": 3504740,
            "get_star_ts": 1704613932
          },
          "2": {
            "get_star_ts": 1704615865,
            "star_index": 3504844
          }
        }
      },
      "stars": 23,
      "global_score": 0
    },
    "2039943": {
      "global_score": 0,
      "stars": 6,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 148467,
            "get_star_ts": 1701446479
          },
          "2": {
            "star_index": 159124,
            "get_star_ts": 1701449121
          }
        },
        "2": {
          "1": {
            "star_index": 695957,
            "get_star_ts": 1701630294
          },
          "2": {
            "get_star_ts": 1701630506,
            "star_index": 696636
          }
        },
        "4": {
          "1": {
            "star_index": 1799483,
            "get_star_ts": 1702070735
          },
          "2": {
            "star_index": 1923453,
            "get_star_ts": 1702134602
          }
        }
      },
      "local_score": 500,
      "last_star_ts": 1702134602,
      "id": 2039943,
      "name": "Jordan Holland"
    },
    "2251856": {
      "local_score": 103,
      "last_star_ts": 1701810934,
      "id": 2251856,
      "name": "Christine Saw",
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 1203536,
            "get_star_ts": 1701809017
          },
          "2": {
            "star_index": 1209224,
            "get_star_ts": 1701810934
          }
        }
      },
      "stars": 2,
      "global_score": 0
    },
    "2251871": {
      "name": "sahasmehta",
      "local_score": 3586,
      "last_star_ts": 1704299607,
      "id": 2251871,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 915903,
            "get_star_ts": 1701700438
          },
          "2": {
            "get_star_ts": 1701703212,
            "star_index": 926282
          }
        },
        "2": {
          "1": {
            "star_index": 941298,
            "get_star_ts": 1701707149
          },
          "2": {
            "get_star_ts": 1701707592,
            "star_index": 942930
          }
        },
        "3": {
          "1": {
            "star_index": 948604,
            "get_star_ts": 1701709128
          },
          "2": {
            "star_index": 949789,
            "get_star_ts": 1701709459
          }
        },
        "4": {
          "1": {
            "star_index": 954871,
            "get_star_ts": 1701710914
          },
          "2": {
            "star_index": 958150,
            "get_star_ts": 1701711835
          }
        },
        "5": {
          "1": {
            "star_index": 1170499,
            "get_star_ts": 1701796828
          },
          "2": {
            "get_star_ts": 1701804701,
            "star_index": 1191312
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1701873426,
            "star_index": 1374597
          },
          "2": {
            "star_index": 1377086,
            "get_star_ts": 1701874298
          }
        },
        "7": {
          "1": {
            "star_index": 1566100,
            "get_star_ts": 1701960958
          },
          "2": {
            "get_star_ts": 1701961815,
            "star_index": 1568137
          }
        },
        "8": {
          "1": {
            "star_index": 1757234,
            "get_star_ts": 1702050021
          },
          "2": {
            "star_index": 1769913,
            "get_star_ts": 1702055564
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1702259121,
            "star_index": 2127113
          },
          "2": {
            "star_index": 2127203,
            "get_star_ts": 1702259248
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1702262522,
            "star_index": 2129593
          },
          "2": {
            "star_index": 2130229,
            "get_star_ts": 1702263458
          }
        },
        "11": {
          "1": {
            "star_index": 2223616,
            "get_star_ts": 1702312738
          },
          "2": {
            "star_index": 2247807,
            "get_star_ts": 1702325953
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1702481053,
            "star_index": 2440327
          },
          "2": {
            "star_index": 2441485,
            "get_star_ts": 1702481916
          }
        },
        "13": {
          "1": {
            "star_index": 2742156,
            "get_star_ts": 1702740804
          },
          "2": {
            "star_index": 2742793,
            "get_star_ts": 1702741313
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1702575058,
            "star_index": 2553199
          },
          "2": {
            "star_index": 2562675,
            "get_star_ts": 1702583627
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1702657567,
            "star_index": 2657020
          },
          "2": {
            "get_star_ts": 1702669667,
            "star_index": 2669868
          }
        },
        "16": {
          "1": {
            "star_index": 3469102,
            "get_star_ts": 1704299607
          }
        },
        "19": {
          "1": {
            "star_index": 2991322,
            "get_star_ts": 1703012979
          }
        },
        "21": {
          "1": {
            "get_star_ts": 1703701309,
            "star_index": 3362027
          }
        },
        "23": {
          "1": {
            "get_star_ts": 1704298341,
            "star_index": 3468843
          },
          "2": {
            "get_star_ts": 1704298746,
            "star_index": 3468932
          }
        },
        "24": {
          "1": {
            "star_index": 3360281,
            "get_star_ts": 1703696484
          }
        }
      },
      "stars": 36,
      "global_score": 0
    },
    "2251910": {
      "stars": 15,
      "global_score": 0,
      "id": 2251910,
      "last_star_ts": 1702671910,
      "local_score": 1313,
      "name": "Sean",
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 386443,
            "get_star_ts": 1701522499
          },
          "2": {
            "star_index": 401946,
            "get_star_ts": 1701526687
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701535054,
            "star_index": 432543
          },
          "2": {
            "star_index": 433880,
            "get_star_ts": 1701535415
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1701647486,
            "star_index": 747358
          },
          "2": {
            "get_star_ts": 1701654850,
            "star_index": 757895
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1701741495,
            "star_index": 1039597
          },
          "2": {
            "get_star_ts": 1702086797,
            "star_index": 1820577
          }
        },
        "5": {
          "1": {
            "star_index": 1949958,
            "get_star_ts": 1702146876
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1702151409,
            "star_index": 1958306
          },
          "2": {
            "get_star_ts": 1702151816,
            "star_index": 1959069
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1702165303,
            "star_index": 1982789
          },
          "2": {
            "star_index": 1987621,
            "get_star_ts": 1702169652
          }
        },
        "10": {
          "1": {
            "star_index": 2122977,
            "get_star_ts": 1702254058
          }
        },
        "15": {
          "1": {
            "star_index": 2672237,
            "get_star_ts": 1702671910
          }
        }
      }
    },
    "2252096": {
      "stars": 22,
      "global_score": 0,
      "name": "Crystal Meyers",
      "last_star_ts": 1704377909,
      "local_score": 2248,
      "id": 2252096,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701451334,
            "star_index": 167787
          },
          "2": {
            "get_star_ts": 1701475090,
            "star_index": 243455
          }
        },
        "2": {
          "1": {
            "star_index": 403373,
            "get_star_ts": 1701527070
          },
          "2": {
            "get_star_ts": 1701527768,
            "star_index": 405941
          }
        },
        "3": {
          "1": {
            "star_index": 752797,
            "get_star_ts": 1701650849
          },
          "2": {
            "get_star_ts": 1701657816,
            "star_index": 761365
          }
        },
        "4": {
          "1": {
            "star_index": 793243,
            "get_star_ts": 1701668875
          },
          "2": {
            "get_star_ts": 1701730225,
            "star_index": 1021299
          }
        },
        "5": {
          "1": {
            "star_index": 1155894,
            "get_star_ts": 1701791403
          },
          "2": {
            "get_star_ts": 1701966034,
            "star_index": 1578486
          }
        },
        "6": {
          "1": {
            "star_index": 1272941,
            "get_star_ts": 1701841022
          },
          "2": {
            "get_star_ts": 1701842636,
            "star_index": 1280087
          }
        },
        "7": {
          "1": {
            "star_index": 1597183,
            "get_star_ts": 1701974381
          },
          "2": {
            "star_index": 1648555,
            "get_star_ts": 1702005866
          }
        },
        "8": {
          "1": {
            "star_index": 1737897,
            "get_star_ts": 1702042121
          },
          "2": {
            "get_star_ts": 1702049898,
            "star_index": 1756926
          }
        },
        "9": {
          "1": {
            "star_index": 1925137,
            "get_star_ts": 1702135353
          },
          "2": {
            "star_index": 1929960,
            "get_star_ts": 1702137441
          }
        },
        "10": {
          "1": {
            "star_index": 2126910,
            "get_star_ts": 1702258856
          }
        },
        "11": {
          "1": {
            "star_index": 2160677,
            "get_star_ts": 1702279896
          },
          "2": {
            "star_index": 2162118,
            "get_star_ts": 1702280596
          }
        },
        "15": {
          "1": {
            "star_index": 3479045,
            "get_star_ts": 1704377909
          }
        }
      }
    },
    "2253216": {
      "stars": 50,
      "global_score": 0,
      "id": 2253216,
      "last_star_ts": 1703511380,
      "local_score": 5516,
      "name": "Jackie Wang",
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701445265,
            "star_index": 143503
          },
          "2": {
            "star_index": 145806,
            "get_star_ts": 1701445836
          }
        },
        "2": {
          "1": {
            "star_index": 468710,
            "get_star_ts": 1701545932
          },
          "2": {
            "get_star_ts": 1701546587,
            "star_index": 470822
          }
        },
        "3": {
          "1": {
            "star_index": 662655,
            "get_star_ts": 1701620149
          },
          "2": {
            "star_index": 666308,
            "get_star_ts": 1701621266
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1701706821,
            "star_index": 940003
          },
          "2": {
            "get_star_ts": 1701707446,
            "star_index": 942431
          }
        },
        "5": {
          "1": {
            "star_index": 1217662,
            "get_star_ts": 1701813910
          },
          "2": {
            "get_star_ts": 1701817770,
            "star_index": 1227045
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1701875546,
            "star_index": 1380474
          },
          "2": {
            "star_index": 1382386,
            "get_star_ts": 1701876227
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1701969761,
            "star_index": 1587116
          },
          "2": {
            "get_star_ts": 1701973046,
            "star_index": 1594224
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1702045367,
            "star_index": 1745729
          },
          "2": {
            "get_star_ts": 1702048375,
            "star_index": 1753123
          }
        },
        "9": {
          "1": {
            "star_index": 1914422,
            "get_star_ts": 1702130735
          },
          "2": {
            "get_star_ts": 1702130994,
            "star_index": 1915029
          }
        },
        "10": {
          "1": {
            "star_index": 2068968,
            "get_star_ts": 1702224201
          },
          "2": {
            "get_star_ts": 1702231745,
            "star_index": 2084062
          }
        },
        "11": {
          "1": {
            "star_index": 2207576,
            "get_star_ts": 1702304342
          },
          "2": {
            "get_star_ts": 1702304533,
            "star_index": 2207961
          }
        },
        "12": {
          "1": {
            "star_index": 2334795,
            "get_star_ts": 1702395945
          },
          "2": {
            "star_index": 2338228,
            "get_star_ts": 1702398409
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1702489006,
            "star_index": 2450659
          },
          "2": {
            "get_star_ts": 1702489449,
            "star_index": 2451203
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1702566905,
            "star_index": 2543372
          },
          "2": {
            "star_index": 2546285,
            "get_star_ts": 1702569177
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1702651290,
            "star_index": 2648212
          },
          "2": {
            "star_index": 2652687,
            "get_star_ts": 1702654362
          }
        },
        "16": {
          "1": {
            "get_star_ts": 1702740727,
            "star_index": 2742066
          },
          "2": {
            "star_index": 2742620,
            "get_star_ts": 1702741169
          }
        },
        "17": {
          "1": {
            "get_star_ts": 1702830368,
            "star_index": 2821754
          },
          "2": {
            "star_index": 2822437,
            "get_star_ts": 1702831036
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1702916208,
            "star_index": 2902400
          },
          "2": {
            "get_star_ts": 1702918485,
            "star_index": 2904918
          }
        },
        "19": {
          "1": {
            "get_star_ts": 1703003559,
            "star_index": 2982674
          },
          "2": {
            "star_index": 3007588,
            "get_star_ts": 1703031911
          }
        },
        "20": {
          "1": {
            "star_index": 3051513,
            "get_star_ts": 1703092961
          },
          "2": {
            "get_star_ts": 1703094220,
            "star_index": 3052502
          }
        },
        "21": {
          "1": {
            "get_star_ts": 1703179389,
            "star_index": 3115594
          },
          "2": {
            "star_index": 3136418,
            "get_star_ts": 1703213485
          }
        },
        "22": {
          "1": {
            "get_star_ts": 1703265363,
            "star_index": 3171158
          },
          "2": {
            "star_index": 3171507,
            "get_star_ts": 1703265816
          }
        },
        "23": {
          "1": {
            "star_index": 3218146,
            "get_star_ts": 1703345926
          },
          "2": {
            "star_index": 3220633,
            "get_star_ts": 1703349418
          }
        },
        "24": {
          "1": {
            "get_star_ts": 1703435982,
            "star_index": 3268262
          },
          "2": {
            "star_index": 3268904,
            "get_star_ts": 1703437183
          }
        },
        "25": {
          "1": {
            "star_index": 3302539,
            "get_star_ts": 1703511374
          },
          "2": {
            "star_index": 3302545,
            "get_star_ts": 1703511380
          }
        }
      }
    },
    "2253630": {
      "stars": 50,
      "global_score": 0,
      "name": "dewhite",
      "id": 2253630,
      "last_star_ts": 1703543651,
      "local_score": 4643,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1702349274,
            "star_index": 2277014
          },
          "2": {
            "get_star_ts": 1702352560,
            "star_index": 2279254
          }
        },
        "2": {
          "1": {
            "star_index": 2452571,
            "get_star_ts": 1702490598
          },
          "2": {
            "star_index": 2455336,
            "get_star_ts": 1702492856
          }
        },
        "3": {
          "1": {
            "star_index": 2477009,
            "get_star_ts": 1702510211
          },
          "2": {
            "star_index": 2539468,
            "get_star_ts": 1702563955
          }
        },
        "4": {
          "1": {
            "star_index": 2542444,
            "get_star_ts": 1702566185
          },
          "2": {
            "get_star_ts": 1702566778,
            "star_index": 2543220
          }
        },
        "5": {
          "1": {
            "star_index": 2670520,
            "get_star_ts": 1702670265
          },
          "2": {
            "star_index": 2925851,
            "get_star_ts": 1702938098
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1702939159,
            "star_index": 2926904
          },
          "2": {
            "star_index": 2927072,
            "get_star_ts": 1702939358
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1702948624,
            "star_index": 2933058
          },
          "2": {
            "star_index": 2933708,
            "get_star_ts": 1702950126
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1702951525,
            "star_index": 2934308
          },
          "2": {
            "star_index": 2975610,
            "get_star_ts": 1702996737
          }
        },
        "9": {
          "1": {
            "star_index": 2984763,
            "get_star_ts": 1703005736
          },
          "2": {
            "get_star_ts": 1703012484,
            "star_index": 2990837
          }
        },
        "10": {
          "1": {
            "star_index": 3229903,
            "get_star_ts": 1703364011
          },
          "2": {
            "get_star_ts": 1703364784,
            "star_index": 3230408
          }
        },
        "11": {
          "1": {
            "star_index": 3231972,
            "get_star_ts": 1703367141
          },
          "2": {
            "get_star_ts": 1703367332,
            "star_index": 3232098
          }
        },
        "12": {
          "1": {
            "star_index": 3233492,
            "get_star_ts": 1703369443
          },
          "2": {
            "get_star_ts": 1703542723,
            "star_index": 3317543
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1703371660,
            "star_index": 3234854
          },
          "2": {
            "get_star_ts": 1703373499,
            "star_index": 3235953
          }
        },
        "14": {
          "1": {
            "star_index": 3237662,
            "get_star_ts": 1703376951
          },
          "2": {
            "get_star_ts": 1703378404,
            "star_index": 3238234
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1703378864,
            "star_index": 3238388
          },
          "2": {
            "get_star_ts": 1703380460,
            "star_index": 3238918
          }
        },
        "16": {
          "1": {
            "get_star_ts": 1703387421,
            "star_index": 3240908
          },
          "2": {
            "get_star_ts": 1703388407,
            "star_index": 3241128
          }
        },
        "17": {
          "1": {
            "get_star_ts": 1703389179,
            "star_index": 3241279
          },
          "2": {
            "get_star_ts": 1703390572,
            "star_index": 3241638
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1703394054,
            "star_index": 3242459
          },
          "2": {
            "get_star_ts": 1703394438,
            "star_index": 3242533
          }
        },
        "19": {
          "1": {
            "star_index": 3244451,
            "get_star_ts": 1703397243
          },
          "2": {
            "star_index": 3247060,
            "get_star_ts": 1703400360
          }
        },
        "20": {
          "1": {
            "get_star_ts": 1703434566,
            "star_index": 3267451
          },
          "2": {
            "star_index": 3268463,
            "get_star_ts": 1703436377
          }
        },
        "21": {
          "1": {
            "get_star_ts": 1703437789,
            "star_index": 3269221
          },
          "2": {
            "star_index": 3270388,
            "get_star_ts": 1703440112
          }
        },
        "22": {
          "1": {
            "star_index": 3276506,
            "get_star_ts": 1703453290
          },
          "2": {
            "star_index": 3290205,
            "get_star_ts": 1703486756
          }
        },
        "23": {
          "1": {
            "star_index": 3271175,
            "get_star_ts": 1703441716
          },
          "2": {
            "get_star_ts": 1703442638,
            "star_index": 3271592
          }
        },
        "24": {
          "1": {
            "get_star_ts": 1703444763,
            "star_index": 3272565
          },
          "2": {
            "star_index": 3275912,
            "get_star_ts": 1703451991
          }
        },
        "25": {
          "1": {
            "star_index": 3317995,
            "get_star_ts": 1703543641
          },
          "2": {
            "get_star_ts": 1703543651,
            "star_index": 3318000
          }
        }
      }
    },
    "2253755": {
      "global_score": 0,
      "stars": 0,
      "completion_day_level": {},
      "name": "fretzslalom",
      "last_star_ts": 0,
      "local_score": 0,
      "id": 2253755
    },
    "2255597": {
      "stars": 0,
      "global_score": 0,
      "local_score": 0,
      "last_star_ts": 0,
      "id": 2255597,
      "name": "Chris Cobb",
      "completion_day_level": {}
    },
    "2255935": {
      "last_star_ts": 1701867028,
      "id": 2255935,
      "local_score": 179,
      "name": "Chazz Hall",
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701699308,
            "star_index": 911600
          },
          "2": {
            "get_star_ts": 1701806108,
            "star_index": 1195217
          }
        },
        "2": {
          "1": {
            "star_index": 1356789,
            "get_star_ts": 1701867028
          }
        }
      },
      "stars": 3,
      "global_score": 0
    },
    "2256609": {
      "global_score": 0,
      "stars": 0,
      "completion_day_level": {},
      "local_score": 0,
      "last_star_ts": 0,
      "id": 2256609,
      "name": "Bishal Niroula"
    },
    "2261385": {
      "last_star_ts": 1701529944,
      "local_score": 370,
      "id": 2261385,
      "name": "Thomas Petrick",
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701464117,
            "star_index": 211781
          },
          "2": {
            "star_index": 219295,
            "get_star_ts": 1701466361
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701529695,
            "star_index": 413044
          },
          "2": {
            "get_star_ts": 1701529944,
            "star_index": 413932
          }
        }
      },
      "stars": 4,
      "global_score": 0
    },
    "2262456": {
      "local_score": 220,
      "last_star_ts": 1702175864,
      "id": 2262456,
      "name": "JoshPDavis",
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1702161319,
            "star_index": 1976825
          },
          "2": {
            "star_index": 1989719,
            "get_star_ts": 1702172107
          }
        },
        "2": {
          "1": {
            "star_index": 1992142,
            "get_star_ts": 1702175385
          },
          "2": {
            "star_index": 1992486,
            "get_star_ts": 1702175864
          }
        }
      },
      "stars": 4,
      "global_score": 0
    },
    "2339631": {
      "last_star_ts": 1704652744,
      "id": 2339631,
      "local_score": 5570,
      "name": "Jackson Reeves",
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 17127,
            "get_star_ts": 1701409750
          },
          "2": {
            "get_star_ts": 1701414630,
            "star_index": 31814
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701497013,
            "star_index": 292352
          },
          "2": {
            "get_star_ts": 1701498380,
            "star_index": 297543
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1701595075,
            "star_index": 580354
          },
          "2": {
            "get_star_ts": 1701627898,
            "star_index": 688329
          }
        },
        "4": {
          "1": {
            "star_index": 792614,
            "get_star_ts": 1701668767
          },
          "2": {
            "get_star_ts": 1701670654,
            "star_index": 801188
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1701758473,
            "star_index": 1071514
          },
          "2": {
            "get_star_ts": 1701939251,
            "star_index": 1513822
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1701841264,
            "star_index": 1274288
          },
          "2": {
            "star_index": 1276013,
            "get_star_ts": 1701841619
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1701930527,
            "star_index": 1491284
          },
          "2": {
            "get_star_ts": 1701935893,
            "star_index": 1505462
          }
        },
        "8": {
          "1": {
            "star_index": 1664115,
            "get_star_ts": 1702013520
          },
          "2": {
            "get_star_ts": 1702020256,
            "star_index": 1684589
          }
        },
        "9": {
          "1": {
            "star_index": 1838679,
            "get_star_ts": 1702099743
          },
          "2": {
            "star_index": 1842988,
            "get_star_ts": 1702100606
          }
        },
        "10": {
          "1": {
            "star_index": 2006562,
            "get_star_ts": 1702189091
          },
          "2": {
            "get_star_ts": 1702256724,
            "star_index": 2125289
          }
        },
        "11": {
          "1": {
            "star_index": 2159978,
            "get_star_ts": 1702279524
          },
          "2": {
            "get_star_ts": 1702310106,
            "star_index": 2218576
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1702780256,
            "star_index": 2780104
          },
          "2": {
            "star_index": 3508179,
            "get_star_ts": 1704648890
          }
        },
        "13": {
          "1": {
            "star_index": 2487599,
            "get_star_ts": 1702529580
          },
          "2": {
            "get_star_ts": 1702753683,
            "star_index": 2757248
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1702538221,
            "star_index": 2505834
          },
          "2": {
            "get_star_ts": 1702698692,
            "star_index": 2690720
          }
        },
        "15": {
          "1": {
            "star_index": 2593405,
            "get_star_ts": 1702617565
          },
          "2": {
            "star_index": 2603781,
            "get_star_ts": 1702621679
          }
        },
        "16": {
          "1": {
            "star_index": 2702262,
            "get_star_ts": 1702707887
          },
          "2": {
            "star_index": 2704687,
            "get_star_ts": 1702709694
          }
        },
        "17": {
          "1": {
            "star_index": 3508689,
            "get_star_ts": 1704652581
          },
          "2": {
            "star_index": 3508712,
            "get_star_ts": 1704652729
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1703372930,
            "star_index": 3235621
          },
          "2": {
            "get_star_ts": 1703373697,
            "star_index": 3236074
          }
        },
        "19": {
          "1": {
            "star_index": 3389231,
            "get_star_ts": 1703802752
          },
          "2": {
            "star_index": 3392241,
            "get_star_ts": 1703816530
          }
        },
        "20": {
          "1": {
            "star_index": 3412413,
            "get_star_ts": 1703915291
          },
          "2": {
            "star_index": 3438543,
            "get_star_ts": 1704082177
          }
        },
        "21": {
          "1": {
            "star_index": 3438886,
            "get_star_ts": 1704087036
          },
          "2": {
            "star_index": 3450885,
            "get_star_ts": 1704174394
          }
        },
        "22": {
          "1": {
            "get_star_ts": 1704583861,
            "star_index": 3502856
          },
          "2": {
            "star_index": 3503170,
            "get_star_ts": 1704587158
          }
        },
        "23": {
          "1": {
            "get_star_ts": 1703380660,
            "star_index": 3238974
          },
          "2": {
            "star_index": 3323024,
            "get_star_ts": 1703559825
          }
        },
        "24": {
          "1": {
            "star_index": 3324397,
            "get_star_ts": 1703567188
          },
          "2": {
            "get_star_ts": 1703746880,
            "star_index": 3373247
          }
        },
        "25": {
          "1": {
            "get_star_ts": 1704601149,
            "star_index": 3504052
          },
          "2": {
            "get_star_ts": 1704652744,
            "star_index": 3508714
          }
        }
      },
      "stars": 50,
      "global_score": 0
    },
    "2340007": {
      "global_score": 0,
      "stars": 4,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 231648,
            "get_star_ts": 1701470294
          },
          "2": {
            "star_index": 237710,
            "get_star_ts": 1701472534
          }
        },
        "2": {
          "1": {
            "star_index": 3504094,
            "get_star_ts": 1704601978
          },
          "2": {
            "star_index": 3504177,
            "get_star_ts": 1704603551
          }
        }
      },
      "last_star_ts": 1704603551,
      "id": 2340007,
      "local_score": 246,
      "name": "Evan Schaeffer"
    },
    "2346547": {
      "stars": 0,
      "global_score": 0,
      "id": 2346547,
      "last_star_ts": 0,
      "local_score": 0,
      "name": "realsethtruax",
      "completion_day_level": {}
    },
    "2430506": {
      "name": "aluaders",
      "last_star_ts": 1705099304,
      "id": 2430506,
      "local_score": 2177,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1702329742,
            "star_index": 2255324
          },
          "2": {
            "star_index": 2263342,
            "get_star_ts": 1702334276
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1702336037,
            "star_index": 2265971
          },
          "2": {
            "star_index": 2267060,
            "get_star_ts": 1702336891
          }
        },
        "3": {
          "1": {
            "star_index": 2371639,
            "get_star_ts": 1702422520
          },
          "2": {
            "get_star_ts": 1702428509,
            "star_index": 2376725
          }
        },
        "4": {
          "1": {
            "star_index": 2440618,
            "get_star_ts": 1702481275
          },
          "2": {
            "get_star_ts": 1702483682,
            "star_index": 2443928
          }
        },
        "5": {
          "1": {
            "star_index": 2457211,
            "get_star_ts": 1702494431
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1702606006,
            "star_index": 2582162
          },
          "2": {
            "star_index": 2646310,
            "get_star_ts": 1702649935
          }
        },
        "7": {
          "1": {
            "star_index": 2662485,
            "get_star_ts": 1702662293
          },
          "2": {
            "get_star_ts": 1702665948,
            "star_index": 2666235
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1702668080,
            "star_index": 2668298
          },
          "2": {
            "star_index": 3473107,
            "get_star_ts": 1704320783
          }
        },
        "9": {
          "1": {
            "star_index": 2671570,
            "get_star_ts": 1702671282
          },
          "2": {
            "star_index": 2674770,
            "get_star_ts": 1702674295
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1702752994,
            "star_index": 2756530
          },
          "2": {
            "get_star_ts": 1702927642,
            "star_index": 2914274
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1702954722,
            "star_index": 2935605
          },
          "2": {
            "get_star_ts": 1702956830,
            "star_index": 2936413
          }
        },
        "13": {
          "1": {
            "star_index": 3121690,
            "get_star_ts": 1703187659
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1703080663,
            "star_index": 3040608
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1704466220,
            "star_index": 3489850
          },
          "2": {
            "star_index": 3493920,
            "get_star_ts": 1704491995
          }
        },
        "16": {
          "1": {
            "get_star_ts": 1704722416,
            "star_index": 3514807
          },
          "2": {
            "star_index": 3545489,
            "get_star_ts": 1705099304
          }
        }
      },
      "stars": 27,
      "global_score": 0
    },
    "2435747": {
      "global_score": 0,
      "stars": 1,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 2548159,
            "get_star_ts": 1702570690
          }
        }
      },
      "name": "whatleymd",
      "id": 2435747,
      "last_star_ts": 1702570690,
      "local_score": 38
    },
    "2441211": {
      "stars": 3,
      "global_score": 0,
      "last_star_ts": 1701804478,
      "id": 2441211,
      "local_score": 174,
      "name": "Austin King",
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701796235,
            "star_index": 1169011
          },
          "2": {
            "star_index": 1186331,
            "get_star_ts": 1701802870
          }
        },
        "2": {
          "1": {
            "star_index": 1190646,
            "get_star_ts": 1701804478
          }
        }
      }
    },
    "2447689": {
      "stars": 4,
      "global_score": 0,
      "last_star_ts": 1702008017,
      "local_score": 255,
      "id": 2447689,
      "name": "Destiny Wilson",
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 233569,
            "get_star_ts": 1701470966
          },
          "2": {
            "star_index": 1042344,
            "get_star_ts": 1701743777
          }
        },
        "2": {
          "1": {
            "star_index": 1649343,
            "get_star_ts": 1702006906
          },
          "2": {
            "star_index": 1650272,
            "get_star_ts": 1702008017
          }
        }
      }
    },
    "2974254": {
      "stars": 10,
      "global_score": 0,
      "name": "Anna McIntosh",
      "id": 2974254,
      "last_star_ts": 1705112503,
      "local_score": 599,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 2983079,
            "get_star_ts": 1703003947
          },
          "2": {
            "star_index": 2984198,
            "get_star_ts": 1703005119
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1703009554,
            "star_index": 2988226
          },
          "2": {
            "get_star_ts": 1703012003,
            "star_index": 2990385
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1704405518,
            "star_index": 3483507
          },
          "2": {
            "star_index": 3546160,
            "get_star_ts": 1705112503
          }
        },
        "4": {
          "1": {
            "star_index": 3060627,
            "get_star_ts": 1703104191
          },
          "2": {
            "star_index": 3471400,
            "get_star_ts": 1704311977
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1704313906,
            "star_index": 3471754
          },
          "2": {
            "star_index": 3472339,
            "get_star_ts": 1704316992
          }
        }
      }
    },
    "3215483": {
      "stars": 0,
      "global_score": 0,
      "local_score": 0,
      "last_star_ts": 0,
      "id": 3215483,
      "name": "Lara Reedick",
      "completion_day_level": {}
    },
    "3215665": {
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701448297,
            "star_index": 155776
          },
          "2": {
            "star_index": 166128,
            "get_star_ts": 1701450903
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701899042,
            "star_index": 1440619
          },
          "2": {
            "get_star_ts": 1701900446,
            "star_index": 1443931
          }
        },
        "4": {
          "1": {
            "star_index": 2240187,
            "get_star_ts": 1702321994
          }
        },
        "5": {
          "1": {
            "star_index": 2473179,
            "get_star_ts": 1702506441
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1702479604,
            "star_index": 2438360
          },
          "2": {
            "get_star_ts": 1702490805,
            "star_index": 2452811
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1701978817,
            "star_index": 1607014
          }
        }
      },
      "name": "Emily Fuller",
      "local_score": 716,
      "last_star_ts": 1702506441,
      "id": 3215665,
      "global_score": 0,
      "stars": 9
    },
    "3215700": {
      "stars": 0,
      "global_score": 0,
      "name": "Chrissy Flicker",
      "last_star_ts": 0,
      "local_score": 0,
      "id": 3215700,
      "completion_day_level": {}
    },
    "3215978": {
      "global_score": 0,
      "stars": 0,
      "completion_day_level": {},
      "last_star_ts": 0,
      "id": 3215978,
      "local_score": 0,
      "name": "Joseph Blake"
    },
    "3217657": {
      "local_score": 3575,
      "last_star_ts": 1705099429,
      "id": 3217657,
      "name": "Anna Mola",
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 984545,
            "get_star_ts": 1701719347
          },
          "2": {
            "star_index": 984683,
            "get_star_ts": 1701719382
          }
        },
        "2": {
          "1": {
            "star_index": 991251,
            "get_star_ts": 1701721167
          },
          "2": {
            "star_index": 995439,
            "get_star_ts": 1701722305
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1701730964,
            "star_index": 1023095
          },
          "2": {
            "star_index": 1024532,
            "get_star_ts": 1701731581
          }
        },
        "4": {
          "1": {
            "star_index": 1027490,
            "get_star_ts": 1701733009
          },
          "2": {
            "get_star_ts": 1701745086,
            "star_index": 1043941
          }
        },
        "5": {
          "1": {
            "star_index": 1164958,
            "get_star_ts": 1701794725
          },
          "2": {
            "star_index": 2131773,
            "get_star_ts": 1702265791
          }
        },
        "6": {
          "1": {
            "star_index": 1451485,
            "get_star_ts": 1701904252
          },
          "2": {
            "star_index": 1451666,
            "get_star_ts": 1701904343
          }
        },
        "7": {
          "1": {
            "star_index": 1491804,
            "get_star_ts": 1701930679
          },
          "2": {
            "get_star_ts": 1701963462,
            "star_index": 1572178
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1702020593,
            "star_index": 1685436
          },
          "2": {
            "star_index": 1761414,
            "get_star_ts": 1702051780
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1702167891,
            "star_index": 1985857
          },
          "2": {
            "get_star_ts": 1702168381,
            "star_index": 1986382
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1702192284,
            "star_index": 2012168
          },
          "2": {
            "star_index": 2120164,
            "get_star_ts": 1702251513
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1702277507,
            "star_index": 2156001
          },
          "2": {
            "get_star_ts": 1702312945,
            "star_index": 2224028
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1702399967,
            "star_index": 2340472
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1702580713,
            "star_index": 2559318
          },
          "2": {
            "get_star_ts": 1702612114,
            "star_index": 2584813
          }
        },
        "14": {
          "1": {
            "star_index": 2654915,
            "get_star_ts": 1702655933
          },
          "2": {
            "get_star_ts": 1702657802,
            "star_index": 2657331
          }
        },
        "15": {
          "1": {
            "star_index": 2671307,
            "get_star_ts": 1702671031
          },
          "2": {
            "star_index": 2691407,
            "get_star_ts": 1702700687
          }
        },
        "16": {
          "1": {
            "get_star_ts": 1702709371,
            "star_index": 2704289
          },
          "2": {
            "get_star_ts": 1702711268,
            "star_index": 2706467
          }
        },
        "17": {
          "1": {
            "star_index": 3540746,
            "get_star_ts": 1705034435
          },
          "2": {
            "star_index": 3540757,
            "get_star_ts": 1705034819
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1705093692,
            "star_index": 3544999
          },
          "2": {
            "star_index": 3545041,
            "get_star_ts": 1705094265
          }
        },
        "19": {
          "1": {
            "star_index": 3545497,
            "get_star_ts": 1705099429
          }
        }
      },
      "stars": 36,
      "global_score": 0
    },
    "3218422": {
      "global_score": 0,
      "stars": 4,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701494876,
            "star_index": 279511
          },
          "2": {
            "get_star_ts": 1702247491,
            "star_index": 2114457
          }
        },
        "2": {
          "1": {
            "star_index": 2134215,
            "get_star_ts": 1702269698
          },
          "2": {
            "get_star_ts": 1702271887,
            "star_index": 2137870
          }
        }
      },
      "last_star_ts": 1702271887,
      "id": 3218422,
      "local_score": 237,
      "name": "Hafees Ali"
    },
    "3223426": {
      "global_score": 0,
      "stars": 0,
      "completion_day_level": {},
      "last_star_ts": 0,
      "id": 3223426,
      "local_score": 0,
      "name": "Siso Ntuli"
    },
    "3224590": {
      "global_score": 0,
      "stars": 1,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701714289,
            "star_index": 966717
          }
        }
      },
      "name": "Adriana Gutierrez-Sureza",
      "id": 3224590,
      "last_star_ts": 1701714289,
      "local_score": 56
    },
    "3224633": {
      "global_score": 0,
      "stars": 3,
      "completion_day_level": {
        "2": {
          "1": {
            "star_index": 1193469,
            "get_star_ts": 1701805513
          },
          "2": {
            "star_index": 1194542,
            "get_star_ts": 1701805879
          }
        },
        "4": {
          "1": {
            "star_index": 1234122,
            "get_star_ts": 1701821745
          }
        }
      },
      "name": "TheMashcraft",
      "last_star_ts": 1701821745,
      "local_score": 209,
      "id": 3224633
    },
    "3226745": {
      "stars": 2,
      "global_score": 0,
      "name": "Eugene Kim",
      "last_star_ts": 1701717900,
      "local_score": 186,
      "id": 3226745,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701447090,
            "star_index": 150951
          }
        },
        "4": {
          "1": {
            "star_index": 979330,
            "get_star_ts": 1701717900
          }
        }
      }
    },
    "3250483": {
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701409868,
            "star_index": 17588
          },
          "2": {
            "get_star_ts": 1701412848,
            "star_index": 26857
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701497735,
            "star_index": 295197
          },
          "2": {
            "star_index": 298095,
            "get_star_ts": 1701498539
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1701607590,
            "star_index": 621651
          },
          "2": {
            "star_index": 638264,
            "get_star_ts": 1701612679
          }
        },
        "4": {
          "1": {
            "star_index": 794932,
            "get_star_ts": 1701669197
          },
          "2": {
            "get_star_ts": 1701709077,
            "star_index": 948399
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1701786258,
            "star_index": 1141976
          },
          "2": {
            "get_star_ts": 1701832619,
            "star_index": 1246409
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1701875497,
            "star_index": 1380347
          },
          "2": {
            "get_star_ts": 1701876376,
            "star_index": 1382775
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1701977290,
            "star_index": 1603523
          },
          "2": {
            "star_index": 1740492,
            "get_star_ts": 1702043209
          }
        },
        "8": {
          "1": {
            "star_index": 1755255,
            "get_star_ts": 1702049235
          },
          "2": {
            "get_star_ts": 1702073943,
            "star_index": 1805491
          }
        },
        "9": {
          "1": {
            "star_index": 1990045,
            "get_star_ts": 1702172533
          },
          "2": {
            "star_index": 1990276,
            "get_star_ts": 1702172848
          }
        },
        "10": {
          "1": {
            "star_index": 2132901,
            "get_star_ts": 1702267542
          },
          "2": {
            "get_star_ts": 1702386950,
            "star_index": 2322693
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1702417986,
            "star_index": 2365845
          },
          "2": {
            "get_star_ts": 1702428863,
            "star_index": 2376969
          }
        },
        "12": {
          "1": {
            "star_index": 2481455,
            "get_star_ts": 1702516947
          },
          "2": {
            "get_star_ts": 1702958625,
            "star_index": 2937091
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1703041480,
            "star_index": 3011481
          },
          "2": {
            "star_index": 3071665,
            "get_star_ts": 1703119286
          }
        },
        "14": {
          "1": {
            "star_index": 3074806,
            "get_star_ts": 1703127219
          }
        },
        "15": {
          "1": {
            "star_index": 3214567,
            "get_star_ts": 1703340607
          },
          "2": {
            "star_index": 3269782,
            "get_star_ts": 1703438898
          }
        },
        "16": {
          "1": {
            "get_star_ts": 1703802561,
            "star_index": 3389164
          },
          "2": {
            "get_star_ts": 1703816947,
            "star_index": 3392302
          }
        },
        "18": {
          "1": {
            "star_index": 3492762,
            "get_star_ts": 1704484598
          }
        },
        "19": {
          "1": {
            "star_index": 3515172,
            "get_star_ts": 1704725521
          }
        },
        "21": {
          "1": {
            "get_star_ts": 1705105323,
            "star_index": 3545886
          }
        },
        "25": {
          "1": {
            "get_star_ts": 1704749052,
            "star_index": 3518158
          }
        }
      },
      "last_star_ts": 1705105323,
      "local_score": 3596,
      "id": 3250483,
      "name": "SamGrayson",
      "global_score": 0,
      "stars": 35
    },
    "3250754": {
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 115738,
            "get_star_ts": 1701438309
          },
          "2": {
            "star_index": 133240,
            "get_star_ts": 1701442758
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701526711,
            "star_index": 402043
          },
          "2": {
            "get_star_ts": 1701527033,
            "star_index": 403226
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1701617097,
            "star_index": 652704
          },
          "2": {
            "get_star_ts": 1701618326,
            "star_index": 656655
          }
        },
        "4": {
          "1": {
            "star_index": 897930,
            "get_star_ts": 1701695657
          },
          "2": {
            "get_star_ts": 1701696842,
            "star_index": 902191
          }
        },
        "5": {
          "1": {
            "star_index": 1129735,
            "get_star_ts": 1701781473
          },
          "2": {
            "get_star_ts": 1701790267,
            "star_index": 1152819
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1701870838,
            "star_index": 1367317
          },
          "2": {
            "star_index": 1368033,
            "get_star_ts": 1701871090
          }
        },
        "7": {
          "1": {
            "star_index": 1547929,
            "get_star_ts": 1701953276
          },
          "2": {
            "get_star_ts": 1701955075,
            "star_index": 1552135
          }
        },
        "8": {
          "1": {
            "star_index": 1731419,
            "get_star_ts": 1702039256
          },
          "2": {
            "get_star_ts": 1702048923,
            "star_index": 1754461
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1702127641,
            "star_index": 1907380
          },
          "2": {
            "get_star_ts": 1702127837,
            "star_index": 1907808
          }
        },
        "10": {
          "1": {
            "star_index": 2060488,
            "get_star_ts": 1702219930
          },
          "2": {
            "star_index": 2096059,
            "get_star_ts": 1702237927
          }
        },
        "11": {
          "1": {
            "star_index": 2197716,
            "get_star_ts": 1702299025
          },
          "2": {
            "star_index": 2209695,
            "get_star_ts": 1702305441
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1702423221,
            "star_index": 2372387
          },
          "2": {
            "get_star_ts": 1702500621,
            "star_index": 2465371
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1702474660,
            "star_index": 2431727
          },
          "2": {
            "get_star_ts": 1702474992,
            "star_index": 2432170
          }
        },
        "14": {
          "1": {
            "star_index": 2530931,
            "get_star_ts": 1702557193
          },
          "2": {
            "star_index": 2536351,
            "get_star_ts": 1702561558
          }
        },
        "15": {
          "1": {
            "star_index": 2634702,
            "get_star_ts": 1702641378
          },
          "2": {
            "get_star_ts": 1702646693,
            "star_index": 2641759
          }
        },
        "16": {
          "1": {
            "get_star_ts": 1702736945,
            "star_index": 2737448
          },
          "2": {
            "get_star_ts": 1702738587,
            "star_index": 2739419
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1702917986,
            "star_index": 2904383
          },
          "2": {
            "star_index": 2922803,
            "get_star_ts": 1702935267
          }
        },
        "19": {
          "1": {
            "get_star_ts": 1702994377,
            "star_index": 2973200
          },
          "2": {
            "get_star_ts": 1703018543,
            "star_index": 2996637
          }
        },
        "21": {
          "1": {
            "get_star_ts": 1703165986,
            "star_index": 3104766
          }
        }
      },
      "name": "Hamilton Evans",
      "local_score": 4122,
      "last_star_ts": 1703165986,
      "id": 3250754,
      "global_score": 0,
      "stars": 37
    },
    "3251154": {
      "name": "Allie Moberg",
      "last_star_ts": 1701454627,
      "id": 3251154,
      "local_score": 84,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 179832,
            "get_star_ts": 1701454627
          }
        }
      },
      "stars": 1,
      "global_score": 0
    },
    "3251410": {
      "name": "Tj Crawfo",
      "local_score": 178,
      "last_star_ts": 1703788531,
      "id": 3251410,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1703695177,
            "star_index": 3359768
          },
          "2": {
            "star_index": 3381595,
            "get_star_ts": 1703779939
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1703788508,
            "star_index": 3384537
          },
          "2": {
            "get_star_ts": 1703788531,
            "star_index": 3384543
          }
        }
      },
      "stars": 4,
      "global_score": 0
    },
    "3251618": {
      "last_star_ts": 1701722137,
      "local_score": 120,
      "id": 3251618,
      "name": "kalslo",
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 984239,
            "get_star_ts": 1701719257
          },
          "2": {
            "get_star_ts": 1701722137,
            "star_index": 994810
          }
        }
      },
      "stars": 2,
      "global_score": 0
    },
    "3251826": {
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 212243,
            "get_star_ts": 1701464261
          },
          "2": {
            "star_index": 3341185,
            "get_star_ts": 1703623433
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701624341,
            "star_index": 676650
          },
          "2": {
            "get_star_ts": 1701625057,
            "star_index": 679097
          }
        },
        "3": {
          "1": {
            "star_index": 3346400,
            "get_star_ts": 1703637884
          },
          "2": {
            "get_star_ts": 1703789364,
            "star_index": 3384784
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1704837292,
            "star_index": 3526508
          }
        }
      },
      "name": "chrismaltusch",
      "local_score": 482,
      "last_star_ts": 1704837292,
      "id": 3251826,
      "global_score": 0,
      "stars": 7
    },
    "3252014": {
      "global_score": 0,
      "stars": 12,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701721664,
            "star_index": 993053
          },
          "2": {
            "get_star_ts": 1701724002,
            "star_index": 1001652
          }
        },
        "2": {
          "1": {
            "star_index": 1204197,
            "get_star_ts": 1701809230
          },
          "2": {
            "star_index": 1207299,
            "get_star_ts": 1701810281
          }
        },
        "3": {
          "1": {
            "star_index": 1395938,
            "get_star_ts": 1701881302
          },
          "2": {
            "get_star_ts": 1701881484,
            "star_index": 1396419
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1701885270,
            "star_index": 1405910
          },
          "2": {
            "get_star_ts": 1701969451,
            "star_index": 1586416
          }
        },
        "5": {
          "1": {
            "star_index": 1588267,
            "get_star_ts": 1701970262
          },
          "2": {
            "get_star_ts": 1701973799,
            "star_index": 1595876
          }
        },
        "6": {
          "1": {
            "star_index": 1622297,
            "get_star_ts": 1701985267
          },
          "2": {
            "star_index": 1625939,
            "get_star_ts": 1701986911
          }
        }
      },
      "last_star_ts": 1701986911,
      "local_score": 902,
      "id": 3252014,
      "name": "moleary992"
    },
    "3252043": {
      "name": "jackiew-slalom",
      "id": 3252043,
      "last_star_ts": 0,
      "local_score": 0,
      "completion_day_level": {},
      "stars": 0,
      "global_score": 0
    },
    "3255428": {
      "stars": 8,
      "global_score": 0,
      "name": "Douglas Yoon",
      "local_score": 659,
      "last_star_ts": 1701925468,
      "id": 3255428,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 430767,
            "get_star_ts": 1701534581
          },
          "2": {
            "get_star_ts": 1701537437,
            "star_index": 441130
          }
        },
        "2": {
          "1": {
            "star_index": 449663,
            "get_star_ts": 1701539945
          },
          "2": {
            "star_index": 451518,
            "get_star_ts": 1701540499
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1701652682,
            "star_index": 755179
          },
          "2": {
            "star_index": 769470,
            "get_star_ts": 1701665115
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1701923482,
            "star_index": 1471044
          },
          "2": {
            "get_star_ts": 1701925468,
            "star_index": 1472644
          }
        }
      }
    },
    "3296685": {
      "name": "Alex Sieland",
      "last_star_ts": 1702263368,
      "local_score": 216,
      "id": 3296685,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 2011592,
            "get_star_ts": 1702191885
          },
          "2": {
            "get_star_ts": 1702222922,
            "star_index": 2066304
          }
        },
        "2": {
          "1": {
            "star_index": 2129984,
            "get_star_ts": 1702263094
          },
          "2": {
            "get_star_ts": 1702263368,
            "star_index": 2130172
          }
        }
      },
      "stars": 4,
      "global_score": 0
    },
    "3301258": {
      "global_score": 0,
      "stars": 21,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 188413,
            "get_star_ts": 1701457120
          },
          "2": {
            "star_index": 199620,
            "get_star_ts": 1701460486
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1701529794,
            "star_index": 413392
          },
          "2": {
            "get_star_ts": 1701561678,
            "star_index": 512135
          }
        },
        "3": {
          "1": {
            "star_index": 948489,
            "get_star_ts": 1701709099
          },
          "2": {
            "get_star_ts": 1701722877,
            "star_index": 997544
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1701727575,
            "star_index": 1013712
          },
          "2": {
            "star_index": 1371891,
            "get_star_ts": 1701872482
          }
        },
        "5": {
          "1": {
            "star_index": 1392817,
            "get_star_ts": 1701880099
          },
          "2": {
            "get_star_ts": 1701944182,
            "star_index": 1526795
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1701888896,
            "star_index": 1414730
          },
          "2": {
            "star_index": 1415279,
            "get_star_ts": 1701889106
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1701938788,
            "star_index": 1512641
          },
          "2": {
            "get_star_ts": 1701941883,
            "star_index": 1520667
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1702140441,
            "star_index": 1936794
          },
          "2": {
            "star_index": 1981024,
            "get_star_ts": 1702164002
          }
        },
        "9": {
          "1": {
            "star_index": 2069495,
            "get_star_ts": 1702224428
          },
          "2": {
            "star_index": 2069966,
            "get_star_ts": 1702224671
          }
        },
        "10": {
          "1": {
            "star_index": 2335132,
            "get_star_ts": 1702396196
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1702321713,
            "star_index": 2239690
          },
          "2": {
            "star_index": 2328610,
            "get_star_ts": 1702391534
          }
        }
      },
      "name": "Alfredo Bird",
      "id": 3301258,
      "last_star_ts": 1702396196,
      "local_score": 1977
    },
    "3326353": {
      "global_score": 0,
      "stars": 41,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 15077,
            "get_star_ts": 1701409237
          },
          "2": {
            "get_star_ts": 1701409916,
            "star_index": 17740
          }
        },
        "2": {
          "1": {
            "star_index": 288453,
            "get_star_ts": 1701496199
          },
          "2": {
            "get_star_ts": 1701496498,
            "star_index": 289971
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1701589056,
            "star_index": 565135
          },
          "2": {
            "star_index": 567154,
            "get_star_ts": 1701589888
          }
        },
        "4": {
          "1": {
            "star_index": 913913,
            "get_star_ts": 1701699922
          },
          "2": {
            "star_index": 915809,
            "get_star_ts": 1701700414
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1701756467,
            "star_index": 1065497
          },
          "2": {
            "get_star_ts": 1701757777,
            "star_index": 1069540
          }
        },
        "6": {
          "1": {
            "star_index": 1256978,
            "get_star_ts": 1701839415
          },
          "2": {
            "get_star_ts": 1701839464,
            "star_index": 1257677
          }
        },
        "7": {
          "1": {
            "star_index": 1481244,
            "get_star_ts": 1701927917
          },
          "2": {
            "get_star_ts": 1701929200,
            "star_index": 1486703
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1702051085,
            "star_index": 1759784
          },
          "2": {
            "get_star_ts": 1702052224,
            "star_index": 1762436
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1702351866,
            "star_index": 2278771
          },
          "2": {
            "star_index": 2278982,
            "get_star_ts": 1702352146
          }
        },
        "10": {
          "1": {
            "star_index": 2282222,
            "get_star_ts": 1702357308
          },
          "2": {
            "star_index": 2327399,
            "get_star_ts": 1702390631
          }
        },
        "11": {
          "1": {
            "star_index": 2343586,
            "get_star_ts": 1702402327
          },
          "2": {
            "get_star_ts": 1702405133,
            "star_index": 2347134
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1702504076,
            "star_index": 2470105
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1702483733,
            "star_index": 2443975
          },
          "2": {
            "get_star_ts": 1702497111,
            "star_index": 2460426
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1702530784,
            "star_index": 2489993
          },
          "2": {
            "star_index": 2538558,
            "get_star_ts": 1702563269
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1702651430,
            "star_index": 2648424
          },
          "2": {
            "star_index": 2651059,
            "get_star_ts": 1702653196
          }
        },
        "16": {
          "1": {
            "star_index": 2802155,
            "get_star_ts": 1702810741
          },
          "2": {
            "star_index": 2802719,
            "get_star_ts": 1702811354
          }
        },
        "17": {
          "1": {
            "get_star_ts": 1702939049,
            "star_index": 2926805
          },
          "2": {
            "star_index": 3043914,
            "get_star_ts": 1703084404
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1702878731,
            "star_index": 2862578
          },
          "2": {
            "get_star_ts": 1702929544,
            "star_index": 2916339
          }
        },
        "19": {
          "1": {
            "star_index": 3046020,
            "get_star_ts": 1703086656
          },
          "2": {
            "star_index": 3075944,
            "get_star_ts": 1703130473
          }
        },
        "20": {
          "1": {
            "star_index": 3077313,
            "get_star_ts": 1703134658
          },
          "2": {
            "get_star_ts": 1703165509,
            "star_index": 3104385
          }
        },
        "21": {
          "1": {
            "get_star_ts": 1703137516,
            "star_index": 3081862
          }
        },
        "23": {
          "1": {
            "star_index": 3216693,
            "get_star_ts": 1703343849
          }
        }
      },
      "local_score": 4549,
      "last_star_ts": 1703343849,
      "id": 3326353,
      "name": "Scott Hankinson"
    },
    "3331157": {
      "stars": 0,
      "global_score": 0,
      "local_score": 0,
      "last_star_ts": 0,
      "id": 3331157,
      "name": "uxr96",
      "completion_day_level": {}
    },
    "3400431": {
      "global_score": 0,
      "stars": 7,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 216309,
            "get_star_ts": 1701465470
          },
          "2": {
            "star_index": 235033,
            "get_star_ts": 1701471500
          }
        },
        "2": {
          "1": {
            "star_index": 429648,
            "get_star_ts": 1701534270
          },
          "2": {
            "get_star_ts": 1701537364,
            "star_index": 440880
          }
        },
        "4": {
          "1": {
            "star_index": 1466123,
            "get_star_ts": 1701917513
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1703021186,
            "star_index": 2999329
          },
          "2": {
            "get_star_ts": 1703023416,
            "star_index": 3001521
          }
        }
      },
      "id": 3400431,
      "last_star_ts": 1703023416,
      "local_score": 566,
      "name": "Amy Flom"
    },
    "3410422": {
      "global_score": 0,
      "stars": 0,
      "completion_day_level": {},
      "last_star_ts": 0,
      "local_score": 0,
      "id": 3410422,
      "name": "raneem rizvi"
    },
    "3429378": {
      "stars": 0,
      "global_score": 0,
      "name": "Barry Ervin",
      "last_star_ts": 0,
      "id": 3429378,
      "local_score": 0,
      "completion_day_level": {}
    },
    "3429559": {
      "completion_day_level": {},
      "local_score": 0,
      "last_star_ts": 0,
      "id": 3429559,
      "name": "adiraina",
      "global_score": 0,
      "stars": 0
    },
    "3432123": {
      "name": "Stanley Sequeira",
      "local_score": 0,
      "last_star_ts": 0,
      "id": 3432123,
      "completion_day_level": {},
      "stars": 0,
      "global_score": 0
    },
    "3432318": {
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1701449606,
            "star_index": 161041
          },
          "2": {
            "star_index": 169034,
            "get_star_ts": 1701451655
          }
        },
        "2": {
          "1": {
            "star_index": 2240701,
            "get_star_ts": 1702322294
          },
          "2": {
            "get_star_ts": 1702322951,
            "star_index": 2241966
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1702510773,
            "star_index": 2477491
          },
          "2": {
            "get_star_ts": 1702515893,
            "star_index": 2480849
          }
        }
      },
      "last_star_ts": 1702515893,
      "local_score": 447,
      "id": 3432318,
      "name": "Hunter Maloof",
      "global_score": 0,
      "stars": 6
    },
    "3650421": {
      "name": "Tony Kablan",
      "last_star_ts": 0,
      "local_score": 0,
      "id": 3650421,
      "completion_day_level": {},
      "stars": 0,
      "global_score": 0
    },
    "3653777": {
      "name": "Ariel Morgan",
      "id": 3653777,
      "last_star_ts": 0,
      "local_score": 0,
      "completion_day_level": {},
      "stars": 0,
      "global_score": 0
    },
    "3660137": {
      "last_star_ts": 0,
      "local_score": 0,
      "id": 3660137,
      "name": "stevenstewart1998",
      "completion_day_level": {},
      "stars": 0,
      "global_score": 0
    },
    "3705049": {
      "stars": 4,
      "global_score": 0,
      "name": "Yebin Choi",
      "last_star_ts": 1703176258,
      "id": 3705049,
      "local_score": 196,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 1581019,
            "get_star_ts": 1701967095
          },
          "2": {
            "star_index": 2444784,
            "get_star_ts": 1702484359
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1702652396,
            "star_index": 2649917
          },
          "2": {
            "star_index": 3113089,
            "get_star_ts": 1703176258
          }
        }
      }
    },
    "3707833": {
      "global_score": 0,
      "stars": 0,
      "completion_day_level": {},
      "name": null,
      "last_star_ts": 0,
      "id": 3707833,
      "local_score": 0
    },
    "3707861": {
      "stars": 0,
      "global_score": 0,
      "name": "rgwilcocks",
      "id": 3707861,
      "last_star_ts": 0,
      "local_score": 0,
      "completion_day_level": {}
    },
    "3707944": {
      "global_score": 0,
      "stars": 0,
      "completion_day_level": {},
      "name": "jordansharpe",
      "last_star_ts": 0,
      "local_score": 0,
      "id": 3707944
    },
    "3763602": {
      "stars": 1,
      "global_score": 0,
      "last_star_ts": 1702482457,
      "id": 3763602,
      "local_score": 39,
      "name": "Jordan Remer",
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1702482457,
            "star_index": 2442273
          }
        }
      }
    },
    "3765815": {
      "id": 3765815,
      "last_star_ts": 0,
      "local_score": 0,
      "name": "Chris Armelagos",
      "completion_day_level": {},
      "stars": 0,
      "global_score": 0
    },
    "3879863": {
      "stars": 4,
      "global_score": 0,
      "name": "tedh-slalom",
      "last_star_ts": 1702589198,
      "id": 3879863,
      "local_score": 189,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1702583517,
            "star_index": 2562558
          },
          "2": {
            "star_index": 2564087,
            "get_star_ts": 1702584885
          }
        },
        "2": {
          "1": {
            "star_index": 2567485,
            "get_star_ts": 1702587737
          },
          "2": {
            "star_index": 2569286,
            "get_star_ts": 1702589198
          }
        }
      }
    },
    "3991719": {
      "global_score": 0,
      "stars": 13,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 3517087,
            "get_star_ts": 1704740630
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1704741174,
            "star_index": 3517148
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1705171659,
            "star_index": 3550354
          },
          "2": {
            "get_star_ts": 1705184380,
            "star_index": 3551382
          }
        },
        "5": {
          "1": {
            "star_index": 3550439,
            "get_star_ts": 1705172738
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1705173263,
            "star_index": 3550479
          },
          "2": {
            "star_index": 3551893,
            "get_star_ts": 1705191307
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1705173815,
            "star_index": 3550533
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1705175204,
            "star_index": 3550649
          },
          "2": {
            "get_star_ts": 1705192324,
            "star_index": 3551943
          }
        },
        "9": {
          "1": {
            "star_index": 3550735,
            "get_star_ts": 1705176382
          },
          "2": {
            "get_star_ts": 1705193224,
            "star_index": 3551984
          }
        },
        "10": {
          "1": {
            "star_index": 3551366,
            "get_star_ts": 1705184126
          }
        }
      },
      "last_star_ts": 1705193224,
      "id": 3991719,
      "local_score": 914,
      "name": "Christopher Armelagos"
    }
  }
};

export default Object.values(raw.members)
  .filter(({stars}) => stars)
  .map(member => {
    if(!member.name) {
      member.name = `unknown -- ${member.id}`
    }
    return member;
  });